import { OffresSansPrix } from './OffresSansPrix.jsx';
import { CarteLienClient } from '../../components/CarteLienClient.jsx';
import { useEffect, useRef, useState } from 'react';
import { BonCommandeClient } from '../../components/BonCommandeClient.jsx';
import { EmailsOffre } from '../../components/EmailsOffre.jsx';
import { adressesDeLOffre } from '../../lib/emails-offre';
import { BoutonContacts } from '../../components/BoutonContacts.jsx';
import { ModifierClient } from '../../components/ModifierClient.jsx';
import { ChoixClient } from '../../components/ChoixClient.jsx';
import { MargePiece } from '../../components/MargePiece.jsx';
import { voitLeBenefice, voitLesAttestations, voitLesPrixDesOffres } from '../../lib/access';
import { clientExistant } from '../../lib/contacts';
import { useReglages } from '../../api/reglages.jsx';
import { useDemande } from '../../components/Dialogue.jsx';
import { RelanceParLien } from '../../components/RelanceParLien.jsx';
import { Shell } from '../../components/layout/Shell.jsx';
import { FacturesJointes } from '../../components/FacturesJointes.jsx';
import { MenuEnvoi } from '../../components/MenuEnvoi.jsx';
import { avertissementIban } from '../../lib/iban-manquant';
import { QRCode } from '../../components/QRCode.jsx';
import { SignPad } from '../../components/SignPad.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { FR } from '../../components/ui/FieldRow.jsx';
import { Inp, _inp } from '../../components/ui/Inputs.jsx';
import { TexteReplie } from '../../components/ui/TexteReplie.jsx';
import { CouleurMessage } from '../../components/CouleurMessage.jsx';
import { styleDuMessage } from '../../lib/styles-messages';
import { ChampDesignation } from '../../components/ui/ChampDesignation.jsx';
import { Pill } from '../../components/ui/Pill.jsx';
import { SOC } from '../../constants/company';
import { DEVIS_STYLES, MODELES } from '../../constants/documents';
import { modelesProposes } from '../../constants/modeles';
import { metierCats, metierUnites } from '../../constants/trades';
import { CLE_MODELES } from '../modeles/ModelesPage.jsx';
import { AjoutArticles } from './AjoutArticles.jsx';
import {
  DUREE_APPUI_LONG,
  TOLERANCE_APPUI,
  ZONE_APPUI_LONG,
  bloqueLeDefilementPendant,
  vibre,
} from '../../lib/appui-long';
import { LignesEditor } from './LignesEditor.jsx';
import { OffreIa } from './OffreIa.jsx';
import { RelanceOffre } from './RelanceOffre.jsx';
import { ChampAcompte, ChampPourcent, ChoixTauxTva } from './ChampsConditions.jsx';
import { DocumentA4 } from '../documents/DocumentA4.jsx';
import { fichierDocumentPrepare, ouvreDocument } from '../../api/documents.js';
import { PhotoSheetA4 } from '../documents/PhotoSheetA4.jsx';
import { MediasLigne } from '../../components/MediasLigne.jsx';
import { ChampDescription } from '../../components/ChampDescription.jsx';
import { metEnAttente } from '../../lib/pieces-attente';
import { photoDeLigne, photosAnnexe, photosPlanche } from '../../lib/planche-photos';

import { devisApi, envoisApi, piecesApi } from '../../api/resources';
import { useSession } from '../../api/session.jsx';
import { composeMessage } from '../../lib/envoi';
import { adresseApi } from '../../api/client';
import { AnnexePhotos } from '../../rendu/AnnexePhotos.jsx';
import { dtoVersDevis } from '../../api/mappers';
import { estProvisoire, idCreePour, idDefinitif, idProvisoire } from '../../lib/identifiants';
import { ceQuiManqueDocument, rangsSansTitre } from '../../lib/lignes-document';
import { chantierDuDevis, chantierLie, libelleProjet } from '../../lib/projet';
import { attendReponse, etatOffre, etatOffreSeule } from '../../lib/etat-offre';
import { lignesDeLAssistant, litUneOffreRedigee } from '../../lib/assistant-devis';
import { DEVISE, fmt } from '../../lib/currency';
import { creeDefilementAuBord } from '../../lib/defilement-glisser';
import { joursDepuis } from '../../lib/dates';
import { remEff, remiseDuClient, remiseLigne } from '../../lib/discounts';
import { estBloc } from '../../lib/blocs-lignes';
import { acompteEnAttente } from '../../lib/acompte-en-attente';
import { I18N, LANG, modifierLe, nouveau, trf, tr } from '../../lib/i18n';
import { termesOffre } from '../../lib/terminologie';
import { swissQR } from '../../lib/swiss-qr';
import { docRef } from '../../lib/swiss-refs';
import { nextSeq, numeroDe, numeroPris, plusRecentesEnTete, today, uid } from '../../lib/utils';
import {
  acompteDocument,
  cleDeDeduction,
  htDocument,
  pourcentLisible,
  totauxDocument,
  ttcDocument,
} from '../../lib/vat';
import { prixApplique } from '../../lib/paliers';
import {
  acompteParDefaut,
  echeancePour,
  remiseParDefaut,
  validiteParDefaut,
} from '../../lib/echeances';
import { TAUX_LEGAUX_ACTUELS, tauxTvaParDefaut } from '../../lib/tva';
import { MSG_SANS_TAMPON, tamponVoulu } from '../../lib/tampon';
import { C, DA, DOC_COULEURS } from '../../theme/palette';
import { ChampUnite } from '../../components/ui/ChampUnite.jsx';
import { DernierEnvoi } from '../../components/DernierEnvoi.jsx';
import { signatureDuClient } from '../../lib/signature-offre.js';

/** Ce que devient la signature quand on modifie une offre acceptée. */

/** Avertissement quand le numéro d'une offre déjà envoyée change. */
const AVIS_NUMERO_OFFRE =
  'Le client a déjà reçu cette offre avec l’ancien numéro. Après le changement, renvoie-la-lui.';
const AVIS_OFFRE_FACTUREE =
  '⚠ Cette offre est déjà facturée (n° {0}). Ces factures ne changent pas : la facture finale reprendra la nouvelle version, sous déduction de ce qui est déjà facturé.';
const AVIS_OFFRE_SIGNEE =
  'Vous pouvez encore la modifier. Si vous changez les articles, les prix, la remise ou l’acompte, la signature du client est retirée et l’offre repasse « En attente » : renvoyez-la pour qu’il la signe à nouveau.';

/**
 * Empreinte courte du contenu d'une pièce : le PDF préparé ne sert qu'à la
 * version qu'il montre.
 *
 * @param {object} piece offre
 * @returns {string} empreinte
 */
function empreinteDeLaPiece(piece) {
  const texte = JSON.stringify(piece) || '';
  let h = 5381;
  for (let i = 0; i < texte.length; i++) h = ((h * 33) ^ texte.charCodeAt(i)) >>> 0;
  return h.toString(36) + '-' + texte.length;
}

/**
 * « Acompte 30% », ou « Acompte » seul quand il est écrit en francs : le
 * montant suit, et 30,54 % n'apprendrait rien au patron.
 *
 * @param {object} d offre ou formulaire
 * @returns {string} le libellé
 */
function libelleAcompte(d) {
  return +d?.acompteMontant > 0 ? 'Acompte' : 'Acompte ' + (d?.acompte || 0) + '%';
}

export function DevisPage({
  onNav,
  soc,
  devis,
  setDevis,
  clients,
  setClients,
  chantiers,
  setChantiers,
  factures,
  setFactures,
  stock,
  catalogue,
  setCatalogue,
  setSoc,
  estMixte,
  univers,
  setUnivers,
  initBC,
  rechargeDevis,
  rechargeChantiers,
  rechargeFactures,
  ouvrir,
  onOuvert,
}) {
  const estMag = estMixte ? univers === 'magasin' : soc?.secteur === 'magasin';
  const trLocal = (s) => {
    // Dans une autre langue, le mot de cette langue : passé d'abord par le
    // vocabulaire suisse (« Offre détaillée »), il restait à moitié français.
    if (!String(LANG).startsWith('fr')) return (I18N[LANG] && I18N[LANG][s]) || s;
    const _p = soc?.pays;
    const _lg = !_p || _p === 'CH' ? 'fr-CH' : soc?.lang || LANG;
    return (I18N[_lg] && I18N[_lg][s]) || (I18N[LANG] && I18N[LANG][s]) || s;
  };
  // Le nom de la piece — « offre » ou « devis » — vient de Reglages → Documents,
  // par la meme regle que le PDF, le courriel et la page du client.
  const termes = termesOffre(soc, { estMag });
  const motDoc = termes.mot;
  // « Nouveau offre » : le mot change avec le metier et avec la langue —
  // « devis » au batiment, « offre » au magasin, et la traduction suisse
  // romande rend « devis » par « offre » elle aussi. L'article suit donc le
  // mot, il ne se decide pas d'apres le secteur.
  const [view, setView] = useState('liste');
  const [selId, setSelId] = useState(null);
  const [dQ, setDQ] = useState('');
  const [dFilt, setDFilt] = useState('tous');
  const [dYear, setDYear] = useState('tous');
  const [style, setStyle] = useState(soc?.devisStyle || 'suisse');
  const [docCol, setDocCol] = useState(soc?.docCouleur || 'neutre');
  const [styleSaved, setStyleSaved] = useState(false);
  const [numOuvert, setNumOuvert] = useState(false);
  const [newCli, setNewCli] = useState('');
  const [cliMode, setCliMode] = useState(null);
  const [cliForm, setCliForm] = useState({ nom: '', adr: '', npa: '', tel: '', email: '' });
  const [qrEtape, setQrEtape] = useState('doc');
  const [sig, setSig] = useState('');
  const [editId, setEditId] = useState(null);
  const [openLine, setOpenLine] = useState(null);
  const [dragIdD, setDragIdD] = useState(null);
  const listRefD = useRef(null);
  const dragRefD = useRef({ id: null });
  const pressRefD = useRef({ id: null, y0: 0, engaged: false });
  // Un glissé qui s'achève sur la ligne déplacée ne doit pas l'ouvrir.
  const vientDeGlisserD = useRef(false);
  const moveLineD = (from, to) =>
    setDevis((p) =>
      p.map((d) => {
        if (d.id !== selId) return d;
        const a = (d.lignes || []).slice();
        if (to < 0) to = 0;
        if (to > a.length - 1) to = a.length - 1;
        const it = a.splice(from, 1)[0];
        a.splice(to, 0, it);
        return { ...d, lignes: a };
      }),
    );
  // La page défile toute seule quand le doigt approche du bord de l'écran.
  const defileD = useRef(null);
  if (!defileD.current) defileD.current = creeDefilementAuBord();
  useEffect(() => () => defileD.current.arrete(), []);
  // Le lien du courriel « Réponse du client » ouvre l'offre elle-même : le
  // patron y voit qui a signé, quand, et la signature.
  useEffect(() => {
    if (!ouvrir?.devisId) return;
    if (!(devis || []).some((d) => d.id === ouvrir.devisId)) return;
    setSelId(ouvrir.devisId);
    setView('detail');
    if (onOuvert) onOuvert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ouvrir, devis]);
  // La ligne sous le doigt, à la hauteur y de l'écran : appelé à chaque
  // mouvement, et après chaque pas du défilement automatique.
  const placeAD = (y) => {
    const rows = listRefD.current ? listRefD.current.querySelectorAll('[data-lid]') : [];
    const ids = Array.prototype.map.call(rows, function (r) {
      return r.getAttribute('data-lid');
    });
    const ci = ids.indexOf(dragRefD.current.id);
    if (ci < 0) return;
    let tg = rows.length - 1;
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i].getBoundingClientRect();
      if (y < r.top + r.height / 2) {
        tg = i;
        break;
      }
    }
    if (tg !== ci) moveLineD(ci, tg);
  };
  const engageD = (id) => {
    pressRefD.current.engaged = true;
    dragRefD.current = { id: String(id) };
    setOpenLine(null);
    setDragIdD(id);
    defileD.current.demarre(listRefD.current, placeAD);
  };
  const rowMoveD = (e) => {
    const st = pressRefD.current;
    if (st.id == null) return;
    if (!st.engaged) {
      // Au doigt, l'article ne se prend qu'après l'appui long : le doigt qui
      // bouge avant fait défiler la page, rien ne se déplace.
      if (st.auDoigt) {
        if (Math.hypot(e.clientX - st.x0, e.clientY - st.y0) > TOLERANCE_APPUI) rowUpD();
        return;
      }
      if (Math.abs(e.clientY - st.y0) > 6) engageD(st.id);
      else return;
    }
    if (e.cancelable) e.preventDefault();
    defileD.current.suit(e.clientY);
    placeAD(e.clientY);
  };
  const rowUpD = () => {
    const st = pressRefD.current;
    clearTimeout(st.minuterie);
    defileD.current.arrete();
    window.removeEventListener('pointermove', rowMoveD);
    window.removeEventListener('pointerup', rowUpD);
    window.removeEventListener('pointercancel', rowUpD);
    const wasEngaged = st.engaged;
    if (wasEngaged) {
      vientDeGlisserD.current = true;
      setTimeout(() => {
        vientDeGlisserD.current = false;
      }, 0);
    }
    pressRefD.current = { id: null, y0: 0, engaged: false };
    dragRefD.current = { id: null };
    setDragIdD(null);
    // Un toucher bref sans glisser : le clic de la ligne l'ouvre.
  };
  const rowDownD = (e, id, forceNow) => {
    const el = e.currentTarget;
    // À la souris, le navigateur prenait le glissé pour celui d'un texte
    // sélectionné et l'annulait : la ligne ne bougeait plus.
    if (e.pointerType === 'mouse' && e.cancelable) e.preventDefault();
    try {
      window.getSelection()?.removeAllRanges();
    } catch (_) {}
    try {
      if (el && el.setPointerCapture) el.setPointerCapture(e.pointerId);
    } catch (_) {}
    const auDoigt = e.pointerType === 'touch';
    pressRefD.current = {
      id,
      x0: e.clientX,
      y0: e.clientY,
      engaged: false,
      auDoigt,
      // Au doigt : l'article se soulève après un appui long, sans bouger.
      minuterie: auDoigt
        ? setTimeout(() => {
            if (pressRefD.current.id !== id || pressRefD.current.engaged) return;
            vibre();
            engageD(id);
          }, DUREE_APPUI_LONG)
        : null,
    };
    window.addEventListener('pointermove', rowMoveD);
    window.addEventListener('pointerup', rowUpD);
    window.addEventListener('pointercancel', rowUpD);
    if (forceNow && !auDoigt) engageD(id);
  };
  // Tant qu'un article est pris au doigt, la page ne défile pas sous lui.
  useEffect(() => bloqueLeDefilementPendant(() => pressRefD.current.engaged), []);
  const [descLine, setDescLine] = useState(null);
  const [sendOpen, setSendOpen] = useState(false);
  const [optOpen, setOptOpen] = useState(false);
  const [confDel, setConfDel] = useState(false);
  const [lineEdit, setLineEdit] = useState(null);
  const [artQ, setArtQ] = useState('');
  const blankForm = {
    clientId: '',
    plaque: '',
    vehicule: '',
    commandeClient: '',
    emailsEnvoi: [],
    desc: '',
    date: today(),
    delai: '',
    intro: '',
    mentions: '',
    // Combien de jours l'offre reste valable : Réglages → Documents.
    validite: validiteParDefaut(soc),
    // L'acompte et la TVA d'usage de l'entreprise, fixes dans Reglages →
    // Documents : les ressaisir a chaque devis etait la premiere chose qu'on
    // oubliait. Ils ne valent que pour une offre neuve ; une offre ouverte
    // garde ce qu'elle porte (voir startEdit).
    acompte: acompteParDefaut(soc),
    // En pour-cent ; le patron touche « CHF » dans l'offre pour un montant.
    acompteEnFrancs: false,
    acompteMontant: null,
    tvaPct: tauxTvaParDefaut(soc),
    lignes: [],
    remisePct: remiseParDefaut(soc),
  };
  const [form, setForm] = useState(blankForm);
  // Un client créé sur place (à la main, depuis les contacts) porte un
  // identifiant provisoire jusqu'à ce que le serveur l'enregistre ; l'offre
  // reprend alors le définitif. Sans cela, la carte du client disparaissait
  // un instant après sa création, comme sur la facture avant elle.
  const clientDuFormulaire = form?.clientId;
  useEffect(() => {
    if (!estProvisoire(clientDuFormulaire)) return;
    const definitif = idDefinitif(clientDuFormulaire);
    if (definitif !== clientDuFormulaire) {
      setForm((p) => (p && p.clientId === clientDuFormulaire ? { ...p, clientId: definitif } : p));
    }
  }, [clients, clientDuFormulaire]);
  // Les réglages de l'entreprise arrivent du serveur après l'ouverture de
  // l'application : une offre neuve ouverte entre-temps gardait 30 % d'acompte
  // au lieu des 50 % réglés. Tant que l'artisan n'y a pas touché, l'acompte
  // et la TVA suivent le réglage.
  const acompteMaison = acompteParDefaut(soc);
  const tvaMaison = tauxTvaParDefaut(soc);
  const remiseMaison = remiseParDefaut(soc);
  const defautsPrecedents = useRef({
    acompte: acompteMaison,
    tvaPct: tvaMaison,
    remisePct: remiseMaison,
  });
  useEffect(() => {
    const avant = defautsPrecedents.current;
    defautsPrecedents.current = {
      acompte: acompteMaison,
      tvaPct: tvaMaison,
      remisePct: remiseMaison,
    };
    if (editId) return;
    setForm((f) => {
      const maj = {};
      if (!f.acompteEnFrancs && avant.acompte !== acompteMaison && f.acompte === avant.acompte) {
        maj.acompte = acompteMaison;
      }
      if (avant.tvaPct !== tvaMaison && f.tvaPct === avant.tvaPct) maj.tvaPct = tvaMaison;
      if (avant.remisePct !== remiseMaison && (f.remisePct || 0) === avant.remisePct) {
        maj.remisePct = remiseMaison;
      }
      return Object.keys(maj).length ? { ...f, ...maj } : f;
    });
  }, [acompteMaison, tvaMaison, remiseMaison, editId]);
  const { reglageJson, setReglageJson } = useReglages();
  const demande = useDemande();
  const { session } = useSession() || {};
  const estPatron = session?.role === 'patron' || session?.role === 'PATRON';
  const [voirModeles, setVoirModeles] = useState(false);
  const [menuEnvoi, setMenuEnvoi] = useState(false);
  // L'offre relancée par WhatsApp part comme son envoi : PDF joint, salutation,
  // lien et signature.
  const [relanceEnvoi, setRelanceEnvoi] = useState(null);
  // La relance automatique des offres sans réponse, réglée dans Réglages :
  // son délai décide quand une offre passe dans « À relancer ».
  const [relanceAuto, setRelanceAuto] = useState(null);
  useEffect(() => {
    envoisApi
      .reglages()
      .then(setRelanceAuto)
      .catch(() => {});
  }, []);
  const delaiRelance = relanceAuto?.relanceDevisActive
    ? Number(relanceAuto.relanceDevisJours) || 15
    : 30;
  // Relit le dernier envoi au journal après un envoi (e-mail, WhatsApp…).
  const [versionEnvoi, setVersionEnvoi] = useState(0);
  const [dictee, setDictee] = useState('');
  // Factures fournisseur saisies sur un devis neuf, déposées une fois le devis créé.
  const [piecesBrouillon, setPiecesBrouillon] = useState([]);
  // Pièces de l'offre ouverte en A4 : ses photos y paraissent en annexe, comme
  // dans le PDF que le client reçoit. Le bouton PDF les ignorait.
  const [piecesDoc, setPiecesDoc] = useState([]);

  /** Les lignes tirées du texte de l'assistant (voir lignesDeLAssistant). */
  const lignesDeLaDictee = () => {
    const client = (clients || []).find((c) => c.id === form.clientId);
    return lignesDeLAssistant(
      dictee,
      catalogue,
      (a) => (client ? remiseLigne(client, a.id, estMag) || 0 : 0),
      { batiment: !estMag },
    );
  };
  const litLaDictee = (depuisGenerer = false) => {
    if (!dictee.trim()) {
      window.alert('Écrivez ou dictez les travaux d’abord.');
      return;
    }
    const nouvelles = lignesDeLaDictee();
    if (!nouvelles.length) {
      window.alert(
        'Aucune prestation reconnue. Emploie des mots du nom de tes articles, séparés par des virgules.',
      );
      return;
    }
    setForm((p) => ({
      ...p,
      lignes: [...(p.lignes || []), ...nouvelles.map((l) => ({ ...l, id: uid() }))],
    }));
    setDictee('');
    const prixComplets = nouvelles.every((l) => +l.p > 0);
    window.alert(
      depuisGenerer && prixComplets
        ? trf(
            '✓ Tes travaux écrits dans l’assistant sont devenus {0} ligne(s), avec leurs prix. Choisis le client, puis touche encore « Générer ».',
            nouvelles.length,
          )
        : depuisGenerer
          ? trf(
              '✓ Tes travaux écrits dans l’assistant sont devenus {0} ligne(s). Mets les prix, puis touche encore « Générer ».',
              nouvelles.length,
            )
          : trf('✓ {0} ligne(s) ajoutée(s). Vérifie les quantités et les prix.', nouvelles.length),
    );
  };
  /**
   * Reprend le brouillon vérifié de « Faire une offre avec l'IA » : le client
   * choisi (créé s'il est nouveau), l'objet et les lignes, ajoutées à celles
   * déjà saisies. L'offre s'enregistre ensuite comme toute autre.
   */
  const repriseOffreIa = ({ client, titre, lignes }) => {
    let clientId = '';
    if (client?.fiche) {
      clientId = idProvisoire();
      setClients((p) => [...p, { id: clientId, ...client.fiche, remiseGlobale: 0, remises: {} }]);
    } else if (client?.id != null) {
      clientId = client.id;
    }
    setForm((p) => ({
      ...p,
      clientId: clientId || p.clientId,
      desc: p.desc || titre,
      lignes: [...(p.lignes || []), ...lignes],
    }));
    window.alert(
      '✓ ' + lignes.length + ' ligne(s) reprise(s). Vérifie l’offre, puis enregistre-la.',
    );
  };
  // Les exemples livres avec l'application, puis ceux de l'entreprise.
  // Au mix, l'univers choisi décide : le magasin propose ses modèles à lui.
  const modeles = modelesProposes(estMag ? 'magasin' : 'batiment', reglageJson(CLE_MODELES, []));

  /**
   * Ajoute les lignes d'un modele a celles deja saisies.
   *
   * Elles s'ajoutent plutot qu'elles ne remplacent : on charge souvent deux
   * modeles pour un meme chantier, et ecraser ce qui est la surprendrait.
   */
  const chargeModele = (m) => {
    setForm((p) => ({
      ...p,
      // Les lignes des modèles proposés, dans la langue de l'entreprise : elles
      // partaient en français sur l'offre d'une entreprise d'ailleurs.
      lignes: [
        ...(p.lignes || []),
        ...(m.lignes || []).map((l) => ({ ...l, d: tr(l.d), id: uid() })),
      ],
    }));
    setVoirModeles(false);
  };

  /** Enregistre les lignes courantes comme modele de l'entreprise. */
  const enregistreModele = async () => {
    const nom = await demande('Nom du modèle (ex : Rénovation salle de bain) :');
    if (!nom || !nom.trim()) {
      return;
    }
    const propres = reglageJson(CLE_MODELES, []);
    setReglageJson(CLE_MODELES, [
      ...propres,
      // Le modele fige les prestations, pas la remise consentie a ce
      // client-ci : elle se renegocie a chaque affaire. Le tarif degressif,
      // lui, fait partie du prix de la prestation : sans lui, l'offre tiree
      // du modele repassait au prix de base des la premiere ligne.
      {
        nom: nom.trim(),
        lignes: (form.lignes || []).map(({ d, sd, u, q, p: pu, ref, paliers }) => ({
          d,
          sd,
          u,
          q,
          p: pu,
          rem: 0,
          ref,
          ...(paliers && paliers.length ? { paliers } : {}),
        })),
      },
    ]);
    window.alert('✓ Modèle « ' + nom.trim() + ' » enregistré.');
  };
  // Les remises du client s'appliquent quand on le choisit ou qu'on ajoute un
  // article ; une offre ouverte ne se recalcule plus quand elles changent.

  const selD = devis.find((d) => d.id === selId);
  // Le PDF à envoyer se prépare dès que l'offre s'ouvre : au moment de
  // « Envoyer au client », il est prêt au lieu d'attendre le serveur. La
  // version suit le contenu de l'offre, qu'une modification fait préparer à
  // nouveau.
  const cheminPdfD =
    selD && Number.isInteger(selD.id) && selD.statut !== 'Brouillon'
      ? `/devis/${selD.id}/document`
      : undefined;
  const versionPdfD = cheminPdfD ? empreinteDeLaPiece(selD) : '';
  useEffect(() => {
    // Pas pendant la saisie d'une ligne : chaque pause referait le PDF.
    if (!cheminPdfD || view !== 'detail' || openLine !== null) return undefined;
    // Laisse d'abord partir l'enregistrement automatique de l'offre.
    const minuteur = setTimeout(
      () => fichierDocumentPrepare(cheminPdfD, versionPdfD).catch(() => {}),
      2500,
    );
    return () => clearTimeout(minuteur);
  }, [cheminPdfD, versionPdfD, view, openLine]);
  const idDoc = view === 'doc' && Number.isInteger(selD?.id) ? selD.id : null;
  useEffect(() => {
    if (idDoc === null) return undefined;
    let actif = true;
    piecesApi
      .liste('DEVIS', idDoc)
      .then((pieces) => actif && setPiecesDoc(pieces || []))
      .catch(() => actif && setPiecesDoc([]));
    return () => {
      actif = false;
    };
  }, [idDoc]);

  // Une piece enregistree recoit son numero du serveur, et celui que l'ecran
  // lui avait donne ne designe plus rien. Les vues de detail sont gardees par
  // `selD` : sans cette reprise, le composant ne rendait rien du tout, et
  // l'ecran restait blanc apres la generation d'un devis.
  //
  // La reference, elle, ne change pas : elle sert a retrouver la piece sous
  // son nouveau numero. Sans cela l'artisan etait renvoye a la liste a
  // l'instant meme ou il venait d'etablir son devis, et devait le rouvrir.
  useEffect(() => {
    if (selId == null || selD || view === 'liste' || view === 'creer' || view === 'modeles') {
      return;
    }
    // La pièce créée d'abord : son numéro a pu changer en route, si un
    // collègue avait pris le même entre-temps.
    const creee = idCreePour(selId);
    if (creee != null && devis.some((d) => d.id === creee)) {
      setSelId(creee);
      return;
    }
    const memePiece = devis.find((d) => d.num != null && String(d.num) === String(selId));
    if (memePiece) {
      setSelId(memePiece.id);
      return;
    }
    setSelId(null);
    setView('liste');
  }, [selId, selD, view, devis]);
  // La liste annoncait un TTC calcule au seul taux du document, remise globale
  // oubliee : elle ne disait pas la meme chose que le devis ouvert.
  const ttcOf = ttcDocument;

  // totaux du formulaire
  const totauxForm = totauxDocument(form.lignes, form.tvaPct, form.remisePct);
  const remM = totauxForm.remise;
  const ht = Math.max(0, totauxForm.ht);
  const tva = totauxForm.tva;
  const ttc = totauxForm.ttc;
  const aAmt = acompteDocument(
    form.lignes,
    form.tvaPct,
    form.remisePct,
    form.acompte,
    form.acompteMontant,
  );
  const clForm = clients.find((c) => c.id === form.clientId);

  const startNew = (modele, bc) => {
    setEditId(null);
    setPiecesBrouillon([]);
    setForm({
      ...blankForm,
      bonCommande: !!bc,
      lignes: (modele ? modele.lignes : []).map((l) => ({
        id: uid(),
        d: l.d,
        u: l.u,
        q: l.q,
        p: l.p,
        rem: 0,
      })),
      modeleId: modele ? modele.id : null,
    });
    setNumOuvert(false);
    setNewCli('');
    setView('creer');
  };
  useEffect(() => {
    if (initBC) startNew(null, true);
  }, []);
  const startEdit = (d) => {
    setEditId(d.id);
    setForm({
      clientId: d.clientId,
      desc: d.desc || '',
      date: d.date || today(),
      delai: d.delai || '',
      intro: d.intro || '',
      piedMessage: d.piedMessage || '',
      stylesMessages: d.stylesMessages || '',
      mentions: d.mentions || '',
      validite: d.validite || 30,
      acompte: d.acompte || 0,
      // L'acompte écrit en francs reste en francs à la modification.
      acompteMontant: +d.acompteMontant > 0 ? +d.acompteMontant : null,
      acompteEnFrancs: +d.acompteMontant > 0,
      tvaPct: d.tvaPct ?? TAUX_LEGAUX_ACTUELS.normal,
      remisePct: d.remisePct || 0,
      modeleId: d.modeleId,
      chantierId: d.chantierId,
      bonCommande: d.bonCommande,
      // Les champs repris tels quels : sans eux, le formulaire les montrait vides.
      commandeClient: d.commandeClient || '',
      emailsEnvoi: [...(d.emailsEnvoi || [])],
      plaque: d.plaque || '',
      vehicule: d.vehicule || '',
      pieces: (d.pieces || []).map((p) => ({ ...p })),
      lignes: (d.lignes || []).map((l) => ({
        id: uid(),
        d: l.d,
        sd: l.sd || '',
        u: l.u,
        q: l.q,
        p: l.p,
        rem: l.rem || 0,
        ref: l.ref,
        // Sans sa cle, la ligne enregistree en serait une autre, et ses photos
        // et plans seraient effaces avec l'ancienne.
        cle: l.cle,
        // Sans ses paliers, modifier le devis le repassait au prix de base.
        paliers: l.paliers,
        imgs: l.imgs || [],
        // Le taux propre, la TVA appliquée ou non, la ligne en évidence et
        // les articles d'un bloc : modifier l'offre les perdait.
        tva: l.tva,
        taxe: l.taxe,
        hl: l.hl,
        bloc: l.bloc,
      })),
    });
    setNumOuvert(false);
    setView('creer');
  };
  const generer = (lignesSaisies) => {
    // La ligne perdait son identifiant en passant la generation. Toutes les
    // lignes du devis en sortaient donc sans nom : React ne savait plus les
    // distinguer, et surtout, modifier l'une d'elles — le prix, la quantite,
    // la description — les modifiait toutes a la fois, puisque la comparaison
    // portait sur deux identifiants absents.
    const lignesN = (lignesSaisies || form.lignes || []).map((l) => ({
      id: l.id || idProvisoire(),
      d: l.d,
      sd: l.sd || '',
      u: l.u,
      q: +l.q || 0,
      p: +l.p || 0,
      rem: +l.rem || 0,
      ref: l.ref,
      // Le taux propre de la ligne (2,6 % sur l'alimentation) se perdait ici :
      // le devis genere, le PDF et la facture repassaient au taux du document.
      tva: l.tva ?? null,
      cle: l.cle,
      imgs: l.imgs || [],
      // Les tarifs degressifs restaient dans le formulaire : le devis genere
      // repassait au prix de base, et le serveur ne les recevait jamais.
      paliers: l.paliers,
      // Ligne sans TVA, ligne en évidence, articles d'un bloc : gardés aussi.
      taxe: l.taxe,
      hl: l.hl,
      bloc: l.bloc,
    }));
    // Le numéro peut être changé ; deux offres ne partagent jamais le même.
    const numVoulu = String(form.num ?? '').trim();
    if (numVoulu && numeroPris(devis, numVoulu, editId)) {
      alert(trf('Le numéro {0} est déjà utilisé par une autre offre.', numVoulu));
      return;
    }
    if (editId) {
      setDevis((p) => p.map((x) => (x.id === editId ? { ...x, ...form, lignes: lignesN } : x)));
      setSelId(editId);
      setEditId(null);
      setView('detail');
      return;
    }
    const num = numVoulu || nextSeq(devis);
    metEnAttente(num, piecesBrouillon);
    setPiecesBrouillon([]);
    setDevis((p) => [
      {
        ...form,
        id: num,
        num,
        lignes: lignesN,
        statut: 'En attente',
        signDate: null,
        bonCommande: !!form.bonCommande,
        sect: estMag ? 'magasin' : 'batiment',
        // Réglages → Documents dit si le tampon se met d'office sur les offres.
        tampon: tamponVoulu(soc, 'devis') && !!(soc?.tampon || soc?.sigPatron),
      },
      ...p,
    ]);
    setSelId(num);
    setView('detail');
  };
  /** Le devis accepté ouvre-t-il un chantier ? Jamais au magasin. */
  const ouvreUnChantier = (d) => !estMag && d?.sect !== 'magasin';
  const accepter = async (d, signature = sig) => {
    const cl = clients.find((c) => c.id === d.clientId);
    // L'acceptation engage le client : elle porte sa signature et sa date,
    // que seul le point d'entree d'acceptation enregistre. La signature
    // dessinee a l'ecran n'etait jamais transmise, et le serveur refuse
    // desormais un devis « accepte » par simple modification.
    if (typeof d.id === 'number') {
      try {
        const dto = await devisApi.accepte(d.id, { signataire: cl?.nom || '', signature });
        // La collection relit la base : poser le statut a la main laissait un
        // ecart avec ce que la synchronisation connaissait du serveur, et la
        // salve suivante tentait de reecrire un devis signe — refuse.
        if (rechargeDevis) {
          await rechargeDevis();
        } else {
          const relu = dtoVersDevis(dto);
          setDevis((p) => p.map((x) => (x.id === d.id ? { ...x, ...relu } : x)));
        }
        // Le serveur tire les suites de l'acceptation — chantier au batiment,
        // facture d'acompte — exactement comme pour l'acceptation du client
        // par son lien. L'ecran les relit plutot que de les refaire : les
        // creer ici aussi en aurait fait deux.
        if (rechargeChantiers) await rechargeChantiers();
        if (rechargeFactures) await rechargeFactures();
      } catch (e) {
        alert(e?.message || "L'acceptation n'a pas pu être enregistrée.");
        return;
      }
      setQrEtape('accepte');
      setView('qr');
      return;
    } else {
      setDevis((p) =>
        p.map((x) => (x.id === d.id ? { ...x, statut: 'Accepté', signDate: today() } : x)),
      );
    }
    // Une offre du magasin ne devient pas un chantier : elle se livre ou se
    // facture. En Mix, c'est l'univers ou l'offre a ete etablie qui decide.
    if (!ouvreUnChantier(d)) {
      setQrEtape('accepte');
      setView('qr');
      return;
    }
    const newId = 'CH-' + uid().slice(0, 3).toUpperCase();
    setChantiers((p) => [
      ...p,
      {
        id: newId,
        // Le dernier mot du nom d'une entreprise est sa forme juridique : le
        // chantier de « Morin SA » s'appelait « Chantier SA ».
        nom: ('Chantier ' + (cl?.nom || '')).trim(),
        clientId: d.clientId,
        // Le devis d'origine : la facture qui en sera issue retrouve ainsi ce
        // chantier, même quand le client en a plusieurs. Le lien désigne le
        // devis, déjà enregistré : il tient quand la base donne au chantier son
        // identifiant définitif.
        devisId: d.id,
        adr: cl?.adr || '',
        npa: cl?.npa || '',
        statut: 'En cours',
        av: 0,
        // Le montant facture du chantier se compare a des couts hors taxe.
        facture: htDocument(d),
        postes: (d.lignes || []).map((l) => l.d).filter(Boolean),
        sousTraitants: [],
        factures: [],
        pointages: [],
        photos: [],
        plans: [],
        messages: [],
        rapports: [],
        bons: [],
        avenants: [],
        pv: null,
      },
    ]);
    setQrEtape('accepte');
    setView('qr');
  };
  /**
   * Refus recueilli sur la tablette, au bureau ou chez le client.
   *
   * <p>Le bouton ne posait le statut qu'à l'écran : au rechargement, la pièce
   * repassait « En attente » et le client, qui avait dit non, était relancé.
   * Le serveur enregistre le refus et sa date, comme il le fait pour le refus
   * que le client exprime par son lien.
   */
  const refuser = async (d) => {
    if (typeof d.id === 'number') {
      try {
        const dto = await devisApi.refuse(d.id);
        if (rechargeDevis) {
          await rechargeDevis();
        } else {
          const relu = dtoVersDevis(dto);
          setDevis((p) => p.map((x) => (x.id === d.id ? { ...x, ...relu } : x)));
        }
      } catch (e) {
        alert(e?.message || 'Le refus n’a pas pu être enregistré.');
        return;
      }
    } else {
      setDevis((p) =>
        p.map((x) => (x.id === d.id ? { ...x, statut: 'Refusé', refuseLe: today() } : x)),
      );
    }
    setQrEtape('refuse');
  };
  /**
   * Le client a touché « J'accepte » sans le vouloir : le patron remet la
   * pièce refusée, avec le motif. Le serveur annule l'acompte créé avec
   * l'acceptation et supprime le chantier encore vide ; un acompte payé ou une
   * autre facture l'arrête, avec la marche à suivre.
   */
  const annulerLAcceptation = async (d) => {
    const motif = await demande(
      tr(
        'Le client a refusé : l’offre redevient « Refusée ». La facture d’acompte créée à l’acceptation est annulée et le chantier encore vide est supprimé. Pourquoi ? (facultatif)',
      ),
      tr('Accepté par erreur'),
    );
    if (motif === null) return;
    try {
      const r = await devisApi.annuleAcceptation(d.id, motif);
      if (rechargeDevis) await rechargeDevis();
      else {
        const relu = dtoVersDevis(r.offre);
        setDevis((p) => p.map((x) => (x.id === d.id ? { ...x, ...relu } : x)));
      }
      if (rechargeFactures) await rechargeFactures();
      if (rechargeChantiers) await rechargeChantiers();
      const fait = [tr('L’offre est maintenant refusée.')];
      if (r.facturesAnnulees?.length)
        fait.push(trf('Facture d’acompte annulée : n° {0}.', r.facturesAnnulees.join(', ')));
      if (r.chantierSupprime) fait.push(trf('Chantier supprimé : {0}.', r.chantierSupprime));
      if (r.chantierGarde)
        fait.push(
          trf(
            'Le chantier « {0} » est gardé, l’équipe y a déjà travaillé : supprime-le depuis Chantiers si besoin.',
            r.chantierGarde,
          ),
        );
      alert(fait.join('\n'));
    } catch (e) {
      alert(e?.message || tr('L’acceptation n’a pas pu être annulée.'));
    }
  };
  /**
   * Le client a refusé par erreur, ou s'est ravisé : le patron remet l'offre
   * « en attente », et le lien du client permet de nouveau de l'accepter.
   */
  const annulerLeRefus = async (d) => {
    if (
      !window.confirm(
        tr(
          'Le client a refusé par erreur ? L’offre redevient « En attente » et le client pourra de nouveau l’accepter par son lien.',
        ),
      )
    )
      return;
    try {
      const relue = await devisApi.annuleRefus(d.id);
      if (rechargeDevis) await rechargeDevis();
      else {
        const lue = dtoVersDevis(relue);
        setDevis((p) => p.map((x) => (x.id === d.id ? { ...x, ...lue } : x)));
      }
    } catch (e) {
      alert(e?.message || tr('Le refus n’a pas pu être annulé.'));
    }
  };
  /**
   * Repart d'une pièce refusée : mêmes lignes et conditions, nouvelle pièce.
   *
   * <p>Un refus se négocie souvent : le client veut la même chose, moins cher
   * ou sans un poste. Ressaisir vingt lignes pour cela décourageait d'en
   * proposer une nouvelle.
   */
  const dupliquer = (d) => {
    startEdit(d);
    setEditId(null);
    setForm((p) => ({
      ...p,
      date: today(),
      pieces: [],
      // Des lignes neuves : celles de la pièce refusée gardent leurs photos.
      lignes: (p.lignes || []).map((l) => ({ ...l, id: uid(), cle: undefined })),
    }));
  };
  /**
   * Lignes qui retranchent de la facture finale l'acompte déjà facturé.
   *
   * <p>Chaque ligne de la facture d'acompte revient en négatif, au même taux
   * de TVA : la TVA déjà facturée sur l'acompte ne l'est pas deux fois. C'est
   * ce que fait le serveur quand c'est lui qui transforme l'offre.
   */
  const deductionAcompte = (d) => {
    // Tous les acomptes de l'offre, factures d'avancement comprises : une
    // seule déduction laissait le client payer deux fois la deuxième.
    const lies = factures.filter(
      (f) => f.type === 'acompte' && f.statut !== 'Annulée' && String(f.devisId) === String(d.id),
    );
    const acomptes = lies.length
      ? lies
      : [d.acompteFacture && factures.find((f) => (f.num || f.id) === d.acompteFacture)].filter(
          Boolean,
        );
    return acomptes.flatMap((acompte) =>
      (acompte.lignes || []).map((l, rang) => ({
        ...l,
        id: uid(),
        // Les déductions d'un même acompte arrondissent leur TVA ensemble,
        // comme sur l'acompte : le total de l'offre tombe juste.
        cle: cleDeDeduction(acompte.id, rang),
        // Dans la langue des documents, comme la facture qui la porte.
        d: trf('Déduction : {0} (facture n° {1})', l.d || tr('Acompte'), acompte.num || acompte.id),
        p: -(+l.p || 0),
      })),
    );
  };
  /**
   * Travaux en plus signés sur le chantier (avenants) : la facture finale
   * reprenait l'offre seule, et ces travaux n'étaient jamais facturés.
   */
  const lignesAvenants = (ch) =>
    (ch?.avenants || []).flatMap((a) =>
      (a.lignes || []).map((l) => ({
        id: uid(),
        d: trf('Avenant : {0}', l.d || a.motif || ''),
        q: +l.q || 0,
        u: l.u || '',
        p: +l.p || 0,
      })),
    );
  const convertirFacture = (d) => {
    // Un second toucher créait une seconde facture (et sortait le stock deux
    // fois) : celle qui existe déjà est signalée avant d'en refaire une.
    const deja = (factures || []).find(
      (f) =>
        f.devisId === d.id && f.type !== 'acompte' && f.type !== 'avoir' && f.statut !== 'Annulée',
    );
    if (
      deja &&
      !window.confirm(
        trf(
          'Cette offre a déjà sa facture ({0}). Créer quand même une autre facture ?',
          deja.num || deja.id,
        ),
      )
    ) {
      return;
    }
    const num = nextSeq(factures);
    const cl = clients.find((c) => c.id === d.clientId);
    const ch = chantierDuDevis(d, chantiers);
    setFactures((p) => [
      {
        id: num,
        type: 'standard',
        devisId: d.id,
        // Le chantier ouvert a l'acceptation, et non le lien du devis seul,
        // presque toujours vide : la facture sortait avec « Projet — ».
        // La base le retient sous « siteId », une fois le chantier cree.
        chantierId: ch ? ch.id : d.chantierId || '',
        siteId: typeof ch?.id === 'number' ? ch.id : (d.siteId ?? null),
        desc: d.desc || '',
        clientId: d.clientId,
        date: today(),
        // Le delai convenu avec le client, et la remise globale du devis signe :
        // la facture partait a trente jours et au prix plein.
        echeance: echeancePour(cl, soc),
        tvaPct: d.tvaPct ?? TAUX_LEGAUX_ACTUELS.normal,
        remisePct: d.remisePct ?? 0,
        acomptePct: d.acompte ?? d.acomptePct ?? 0,
        sect: d.sect,
        // Le vehicule d'une offre de garage suit sur la facture.
        plaque: d.plaque || '',
        vehicule: d.vehicule || '',
        // Le bon de commande du client suit aussi : sans lui, pas de paiement.
        commandeClient: d.commandeClient || '',
        // Les personnes qui ont reçu l'offre reçoivent aussi la facture.
        emailsEnvoi: [...(d.emailsEnvoi || [])],
        // Rien n'est parti : la facture se relit, puis s'envoie. « Envoyée »
        // d'office, le patron la croyait chez le client, et les rappels se
        // comptaient sur une facture que le client n'avait jamais reçue.
        statut: 'Brouillon',
        paidDate: null,
        lignes: [
          ...(d.lignes || []).map((l) => ({ ...l })),
          ...lignesAvenants(ch),
          ...deductionAcompte(d),
        ],
      },
      ...p,
    ]);
    onNav('factures', { factureId: num });
  };

  // « Offres sans les prix » (Réglages → Accès) : le technicien voit les
  // travaux et les quantités, rien d'autre ; il ne crée ni ne modifie d'offre.
  if (!voitLesPrixDesOffres()) {
    return (
      <OffresSansPrix
        devis={devis}
        clients={clients}
        chantiers={chantiers}
        onNav={onNav}
        soc={soc}
        estMixte={estMixte}
        univers={univers}
        setUnivers={setUnivers}
      />
    );
  }

  /* LISTE */
  if (view === 'liste') {
    const ql = dQ.trim().toLowerCase();
    const dAnnees = [
      ...new Set(devis.map((d) => ('' + (d.date || '')).split('.')[2]).filter(Boolean)),
    ]
      .sort()
      .reverse();
    const liste = plusRecentesEnTete(devis).filter((d) => {
      const cl = clients.find((c) => c.id === d.clientId);
      const okQ =
        !ql ||
        // Le numéro, puis l'identifiant — un nombre, sur lequel `toLowerCase`
        // faisait tomber l'écran à la première lettre tapée.
        String(d.num || '')
          .toLowerCase()
          .includes(ql) ||
        String(d.id ?? '')
          .toLowerCase()
          .includes(ql) ||
        (cl?.nom || '').toLowerCase().includes(ql);
      // Une offre déjà convertie en facture n'attend plus de réponse.
      const facturee = (factures || []).some(
        (f) =>
          f.devisId === d.id &&
          f.type !== 'acompte' &&
          f.type !== 'avoir' &&
          f.statut !== 'Annulée',
      );
      // Une offre reste une offre : devenue facture, payée ou non, elle reste
      // dans la liste, sous « Acceptés », avec le numéro de sa facture. Cachée
      // une fois payée, elle laissait un trou dans la série (47, puis 49).
      const etat = etatOffre(d, factures, chantiers);
      const okF =
        dFilt === 'tous' ||
        (dFilt === 'Accepté'
          ? d.statut === 'Accepté' || etat === 'Facturé' || etat === 'Payé'
          : d.statut === dFilt && !(dFilt === 'En attente' && facturee));
      const okY = dYear === 'tous' || ('' + (d.date || '')).split('.')[2] === dYear;
      return okQ && okF && okY;
    });
    return (
      <Shell
        active="devis"
        onNav={onNav}
        soc={soc}
        pageTitle={'📄 ' + termes.Pluriel}
        estMixte={estMixte}
        univers={univers}
        setUnivers={setUnivers}
      >
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <div
            onClick={() => startNew(null)}
            style={{
              flex: 1,
              background: C.navy,
              borderRadius: 12,
              padding: '15px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
            }}
          >
            <span style={{ fontSize: 20, color: '#fff' }}>＋</span>
            <span style={{ fontSize: 13, fontWeight: 800, color: '#fff' }}>{termes.nouveau}</span>
          </div>
          <div
            onClick={() => onNav('import')}
            style={{
              flexShrink: 0,
              background: C.white,
              border: '1px solid ' + C.navy,
              borderRadius: 12,
              padding: '15px 14px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              color: C.navy,
            }}
            title="Reprendre depuis un autre logiciel"
          >
            <span style={{ fontSize: 16 }}>📥</span>
            <span style={{ fontSize: 11, fontWeight: 800 }}>Importer</span>
          </div>
        </div>
        {!estMag && (
          <div
            onClick={() => startNew(null, true)}
            style={{
              background: C.purple + '12',
              border: '1px solid ' + C.purple,
              borderRadius: 12,
              padding: '12px 14px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 9,
              marginBottom: 8,
            }}
          >
            <span style={{ fontSize: 18 }}>📋</span>
            <div>
              <div style={{ fontSize: 12.5, fontWeight: 800, color: C.purple }}>
                Nouveau bon de commande
              </div>
              <div style={{ fontSize: 8.5, color: C.grey }}>
                Pour sous-traiter une prestation à une autre entreprise
              </div>
            </div>
          </div>
        )}
        <div
          onClick={() => setView('modeles')}
          style={{
            textAlign: 'center',
            fontSize: 10,
            color: C.navy,
            fontWeight: 700,
            marginBottom: 11,
            cursor: 'pointer',
          }}
        >
          … ou partir d'un modèle
        </div>
        <input
          value={dQ}
          onChange={(e) => setDQ(e.target.value)}
          placeholder="🔎 Rechercher (n°, client)"
          style={{ ..._inp, marginBottom: 10 }}
        />
        <div
          style={{ display: 'flex', gap: 6, overflowX: 'auto', marginBottom: 11, paddingBottom: 2 }}
        >
          {[
            ['tous', 'Tous'],
            ['En attente', 'En attente'],
            ['Accepté', 'Acceptés'],
            ['Refusé', 'Refusés'],
          ].map(([k, l]) => (
            <div
              key={k}
              onClick={() => setDFilt(k)}
              style={{
                flexShrink: 0,
                padding: '6px 11px',
                borderRadius: 99,
                fontSize: 9.5,
                fontWeight: 700,
                cursor: 'pointer',
                border: '1px solid ' + (dFilt === k ? C.navy : C.border),
                background: dFilt === k ? C.navy : C.white,
                color: dFilt === k ? '#fff' : C.grey,
              }}
            >
              {l}
            </div>
          ))}
        </div>
        {dAnnees.length > 1 && (
          <div style={{ display: 'flex', gap: 6, overflowX: 'auto', marginBottom: 11 }}>
            {['tous', ...dAnnees].map((y) => (
              <div
                key={y}
                onClick={() => setDYear(y)}
                style={{
                  flexShrink: 0,
                  padding: '6px 11px',
                  borderRadius: 99,
                  fontSize: 9,
                  fontWeight: 700,
                  cursor: 'pointer',
                  border: '1px solid ' + (dYear === y ? C.teal : C.border),
                  background: dYear === y ? C.teal : C.white,
                  color: dYear === y ? '#fff' : C.grey,
                }}
              >
                {y === 'tous' ? '📅 Toutes' : y}
              </div>
            ))}
          </div>
        )}
        {(() => {
          const aRel = devis
            .filter(
              (d) =>
                attendReponse(d, factures) && joursDepuis(d.envoyeLe || d.date) >= delaiRelance,
            )
            .sort((a, b) => joursDepuis(b.envoyeLe || b.date) - joursDepuis(a.envoyeLe || a.date));
          // Les offres à relancer sont en attente : sous « Acceptés » ou
          // « Refusés », le cadre faisait croire qu'une offre en attente
          // était acceptée.
          if (!aRel.length || (dFilt !== 'tous' && dFilt !== 'En attente')) return null;
          return (
            <Card style={{ marginBottom: 11 }}>
              <Bar
                icon="📨"
                title={
                  delaiRelance === 30
                    ? 'À relancer — ' +
                      aRel.length +
                      ' ' +
                      (aRel.length > 1 ? termes.pluriel : termes.mot) +
                      ' sans réponse depuis 1 mois'
                    : trf(
                        'À relancer — {0} {1} sans réponse depuis {2} jours',
                        aRel.length,
                        aRel.length > 1 ? termes.pluriel : termes.mot,
                        delaiRelance,
                      )
                }
                color={C.amber}
              />
              <div style={{ padding: 13 }}>
                {aRel.map((d) => {
                  const cl = clients.find((c) => c.id === d.clientId);
                  const jr = joursDepuis(d.envoyeLe || d.date);
                  const tot = ttcOf(d);
                  const tel = (cl?.tel || '').replace(/[^0-9]/g, '').replace(/^0/, '41');
                  // Le message part chez le client : dans la langue de l'entreprise.
                  const msg = (lien) =>
                    trf(
                      termes.feminin
                        ? 'Bonjour {0}, votre offre {1} ({2}) est toujours valable. Souhaitez-vous la valider ? {3}'
                        : 'Bonjour {0}, votre devis {1} ({2}) est toujours valable. Souhaitez-vous le valider ? {3}',
                      cl?.nom || '',
                      d.num || d.id,
                      DEVISE + ' ' + fmt(tot),
                      lien,
                    );
                  return (
                    <div
                      key={d.id}
                      style={{
                        border: '1px solid ' + C.border,
                        borderRadius: 10,
                        padding: '10px 11px',
                        marginBottom: 8,
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <div>
                          <div style={{ fontSize: 10.5, fontWeight: 800 }}>
                            {d.num || d.id} · {cl?.nom || 'Client'}
                          </div>
                          <div style={{ fontSize: 8.5, color: C.amber, fontWeight: 700 }}>
                            Sans réponse depuis {jr} jours · {DEVISE} {fmt(tot)}
                          </div>
                        </div>
                        <div
                          onClick={() => {
                            setSelId(d.id);
                            setView('detail');
                          }}
                          style={{
                            fontSize: 9,
                            color: C.navy,
                            fontWeight: 700,
                            cursor: 'pointer',
                          }}
                        >
                          Ouvrir ›
                        </div>
                      </div>
                      <RelanceParLien
                        type="devis"
                        id={d.id}
                        email={cl?.email}
                        tel={tel}
                        sujet={'Relance ' + (d.num || d.id)}
                        message={msg}
                        envoiServeur={
                          Number.isInteger(d.id) ? () => envoisApi.envoieDevis(d.id) : undefined
                        }
                        onWhatsApp={() => setRelanceEnvoi(d)}
                        onRelance={() =>
                          setDevis((p) =>
                            p.map((x) => (x.id === d.id ? { ...x, relanceLe: today() } : x)),
                          )
                        }
                      />
                      {d.relanceLe && (
                        <div style={{ fontSize: 8, color: C.muted, marginTop: 5 }}>
                          Dernière relance : {d.relanceLe}
                        </div>
                      )}
                      {!d.relanceLe &&
                        relanceAuto?.relanceDevisActive &&
                        relanceAuto.relanceDevisCanal !== 'WHATSAPP' && (
                          <div
                            style={{ fontSize: 8, color: C.navy, fontWeight: 700, marginTop: 5 }}
                          >
                            {trf(
                              '⏰ Relance automatique au prochain envoi de {0}',
                              relanceAuto.heureEnvoi || '08:00',
                            )}
                          </div>
                        )}
                    </div>
                  );
                })}
              </div>
            </Card>
          );
        })()}
        {liste.length === 0 && (
          <Card>
            <div style={{ padding: 20, textAlign: 'center', color: C.muted, fontSize: 11 }}>
              {termes.aucun}.
            </div>
          </Card>
        )}
        {liste.map((d) => {
          const cl = clients.find((c) => c.id === d.clientId);
          const mod = MODELES.find((m) => m.id === d.modeleId);
          // Dans Offres, rien sur la facture : une offre facturée reste « Accepté ».
          const etat = etatOffreSeule(d, factures, chantiers);
          const sc =
            etat === 'Payé' || etat === 'Accepté'
              ? C.green
              : etat === 'Facturé'
                ? C.teal
                : etat === 'Refusé'
                  ? C.red
                  : C.amber;
          return (
            <Card
              key={d.id}
              style={{
                marginBottom: 9,
                cursor: 'pointer',
                borderLeft: '4px solid ' + (mod?.col || C.navy),
              }}
              onClick={() => {
                setSelId(d.id);
                setView('detail');
              }}
            >
              <div
                style={{
                  padding: '12px 14px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                }}
              >
                <div>
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 3 }}>
                    {mod && <span style={{ fontSize: 13 }}>{mod.icon}</span>}
                    <span style={{ fontSize: 11, fontWeight: 800, color: C.ink }}>
                      {d.num || d.id}
                    </span>
                    {d.bonCommande && (
                      <span
                        style={{
                          fontSize: 7.5,
                          fontWeight: 800,
                          color: C.teal,
                          background: C.teal + '18',
                          borderRadius: 5,
                          padding: '1px 6px',
                        }}
                      >
                        📋 BON DE CMD
                      </span>
                    )}
                  </div>
                  <div style={{ fontSize: 10, color: C.grey }}>{cl?.nom || '—'}</div>
                  <div style={{ fontSize: 8, color: C.muted }}>
                    {d.date}
                    {d.delai ? ' · ' + d.delai : ''}
                  </div>
                  {(() => {
                    // La facture faite depuis l'offre garde son propre numéro.
                    const fac = (factures || []).find(
                      (f) =>
                        f.devisId != null &&
                        String(f.devisId) === String(d.id) &&
                        f.type !== 'acompte' &&
                        f.type !== 'avoir' &&
                        f.statut !== 'Annulée',
                    );
                    return fac ? (
                      <div style={{ fontSize: 8.5, color: C.teal, fontWeight: 700, marginTop: 2 }}>
                        🧾 {trf('Facture n° {0}', fac.num || fac.id)}
                        {fac.statut === 'Payée' ? ' · ' + tr('payée') : ''}
                      </div>
                    ) : null;
                  })()}
                </div>
                <div style={{ textAlign: 'right' }}>
                  <Pill label={etat} color={sc} size={8} />
                  <div style={{ fontSize: 14, fontWeight: 900, color: C.ink, marginTop: 5 }}>
                    {DEVISE} {fmt(ttcOf(d))}
                  </div>
                  {d.acompte > 0 && (
                    <div style={{ fontSize: 8, color: C.muted }}>{libelleAcompte(d)}</div>
                  )}
                </div>
              </div>
            </Card>
          );
        })}
        {relanceEnvoi &&
          (() => {
            const d = relanceEnvoi;
            const clR = clients.find((c) => c.id === d.clientId);
            return (
              <MenuEnvoi
                piece={d}
                nature={termes.Mot}
                client={clR}
                soc={soc}
                relance={{ montant: DEVISE + ' ' + fmt(ttcOf(d)) }}
                onClose={() => setRelanceEnvoi(null)}
                onEnvoye={() =>
                  setDevis((p) => p.map((x) => (x.id === d.id ? { ...x, relanceLe: today() } : x)))
                }
                notePartage={{ type: 'DEVIS', id: d.id }}
                lienType="devis"
                cheminPdf={
                  Number.isInteger(d.id) && d.statut !== 'Brouillon'
                    ? `/devis/${d.id}/document`
                    : undefined
                }
                envoiServeur={Number.isInteger(d.id) ? () => envoisApi.envoieDevis(d.id) : null}
                cibleServeur={adressesDeLOffre(clR, d.emailsEnvoi).join(', ')}
              />
            );
          })()}
      </Shell>
    );
  }

  /* MODÈLES */
  if (view === 'modeles') {
    return (
      <Shell
        active="devis"
        onNav={onNav}
        soc={soc}
        back
        onBack={() => setView('liste')}
        pageTitle="Choisir un modèle"
        estMixte={estMixte}
        univers={univers}
        setUnivers={setUnivers}
      >
        <div
          style={{
            background: C.greenL,
            border: '1px solid ' + C.green + '28',
            borderRadius: 10,
            padding: '10px 12px',
            fontSize: 9,
            color: C.grey,
            marginBottom: 11,
            lineHeight: 1.5,
          }}
        >
          Les lignes sont pré-remplies puis entièrement modifiables.
        </div>
        {MODELES.map((m) => (
          <Card
            key={m.id}
            style={{ marginBottom: 9, cursor: 'pointer', borderLeft: '4px solid ' + m.col }}
            onClick={() => startNew(m)}
          >
            <div
              style={{
                padding: '12px 14px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <div
                  style={{
                    width: 40,
                    height: 40,
                    background: m.col + '15',
                    borderRadius: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 20,
                  }}
                >
                  {m.icon}
                </div>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: C.ink }}>
                    {trLocal(m.nom)}
                  </div>
                  <div style={{ fontSize: 9, color: C.muted }}>
                    {m.lignes.length} ligne{m.lignes.length > 1 ? 's' : ''} · dès {DEVISE}{' '}
                    {fmt(m.lignes.reduce((s, l) => s + (+l.q || 0) * prixApplique(l), 0))}
                  </div>
                </div>
              </div>
              <span style={{ fontSize: 18, color: m.col }}>›</span>
            </div>
          </Card>
        ))}
      </Shell>
    );
  }

  /* CRÉATION */
  if (view === 'creer') {
    // Le menu propose « Bon de commande » — une prestation sous-traitee a une
    // autre entreprise — et l'ecran s'intitulait « Nouvelle offre », demandait
    // un client et proposait de « generer l'offre ». L'artisan n'avait aucun
    // signe d'etre au bon endroit, et decouvrait la nature de sa piece une
    // fois generee.
    const motPiece = form.bonCommande ? 'bon de commande' : motDoc;
    // Le serveur exige une désignation sur chaque ligne : une ligne libre
    // laissée sans titre faisait refuser l'enregistrement (« champs
    // invalides »), et le devis tout juste saisi disparaissait de la liste.
    const ligneSansTitre = rangsSansTitre(form.lignes).length > 0;
    const ceQuiManque = () =>
      ceQuiManqueDocument(form, form.bonCommande ? 'le sous-traitant' : 'le client');
    return (
      <Shell
        active="devis"
        onNav={onNav}
        soc={soc}
        back
        onBack={() => setView('liste')}
        pageTitle={editId ? '✎ ' + modifierLe(motPiece) : nouveau(motPiece)}
        estMixte={estMixte}
        univers={univers}
        setUnivers={setUnivers}
      >
        {/* Client */}
        <Card style={{ marginBottom: 11 }}>
          <Bar icon="👤" title={form.bonCommande ? 'Sous-traitant' : 'Client'} color={C.navy} />
          <div style={{ padding: 13 }}>
            {/* Proposé tout seul, modifiable à tout moment, même une fois l'offre
                envoyée ou signée : le patron décide, l'écran l'avertit. Replié
                sur une petite ligne : on ne le touche presque jamais. */}
            <button
              type="button"
              onClick={() => setNumOuvert((v) => !v)}
              aria-expanded={numOuvert}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                border: 'none',
                background: 'none',
                padding: '0 2px 8px',
                cursor: 'pointer',
                fontSize: 10,
                fontWeight: 700,
                color: C.grey,
              }}
            >
              <span>{tr('Numéro')}</span>
              <span>
                {'N° ' +
                  (form.num ??
                    (editId ? numeroDe(devis.find((x) => x.id === editId)) : nextSeq(devis))) +
                  ' ✎'}
              </span>
            </button>
            {numOuvert && (
              <Inp label={tr('Numéro')}>
                <input
                  aria-label={termes.feminin ? tr('Numéro de l’offre') : tr('Numéro du devis')}
                  value={
                    form.num ??
                    (editId ? numeroDe(devis.find((x) => x.id === editId)) : nextSeq(devis))
                  }
                  onChange={(e) => setForm((p) => ({ ...p, num: e.target.value }))}
                  style={{ ..._inp, marginBottom: 4 }}
                />
              </Inp>
            )}
            {!!editId &&
              form.statut !== 'Brouillon' &&
              form.num != null &&
              form.num.trim() !== numeroDe(devis.find((x) => x.id === editId)) && (
                <div
                  role="note"
                  style={{
                    fontSize: 10,
                    color: '#9a3412',
                    background: '#fff7ed',
                    border: '1px solid #fdba74',
                    borderRadius: 8,
                    padding: '7px 9px',
                    margin: '0 0 10px',
                    lineHeight: 1.45,
                  }}
                >
                  ⚠ {tr(AVIS_NUMERO_OFFRE)}
                </div>
              )}
            {/* Plus la liste de tous les clients avec leurs poubelles : une
                recherche, les derniers clients et, sur demande, tous les
                clients à faire défiler. On supprime un client depuis Clients. */}
            <ChoixClient
              clients={clients}
              clientId={form.clientId}
              recents={[...devis]
                .sort((x, y) => (+y.id || 0) - (+x.id || 0))
                .map((d) => d.clientId)}
              onChoisir={(cl) =>
                setForm((p) => ({
                  ...p,
                  clientId: cl.id,
                  lignes: (p.lignes || []).map((l) =>
                    l.ref ? { ...l, rem: remiseDuClient(cl, l, estMag) } : l,
                  ),
                }))
              }
              onChanger={() => setForm((p) => ({ ...p, clientId: null }))}
            />
            <ModifierClient
              key={form.clientId}
              client={(clients || []).find((c) => c.id === form.clientId)}
              setClients={setClients}
            />
            {!form.clientId && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
                <div style={{ flex: 1 }}>
                  <Btn
                    label="＋ Ajouter manuellement"
                    sm
                    ghost
                    color={C.navy}
                    full
                    onClick={() => {
                      setCliMode(cliMode === 'manuel' ? null : 'manuel');
                      setCliForm({ nom: newCli.trim(), adr: '', npa: '', tel: '', email: '' });
                    }}
                  />
                </div>
                <BoutonContacts
                  sm
                  ghost
                  color={C.teal}
                  onContact={(contact) => {
                    // Le client deja enregistre est repris tel quel : choisir
                    // deux fois la meme personne creait deux clients.
                    const deja = clientExistant(clients, contact);
                    if (deja) {
                      setForm((p) => ({ ...p, clientId: deja.id }));
                      setCliMode(null);
                      return;
                    }
                    // L'adresse etait demandee au carnet puis jetee : le client
                    // arrivait sans, et la facture qui suit le devis partait sans
                    // destinataire ni bulletin de versement.
                    const nid = idProvisoire();
                    setClients((p) => [
                      ...p,
                      { id: nid, ...contact, remiseGlobale: 0, remises: {} },
                    ]);
                    setForm((p) => ({ ...p, clientId: nid }));
                    setCliMode(null);
                  }}
                  onEchec={() => setCliMode('manuel')}
                />
              </div>
            )}
            {!form.clientId && cliMode === 'manuel' && (
              <div
                style={{
                  border: '1px solid ' + C.border,
                  borderRadius: 10,
                  padding: 12,
                  marginTop: 8,
                }}
              >
                <input
                  value={cliForm.nom}
                  onChange={(e) => setCliForm((p) => ({ ...p, nom: e.target.value }))}
                  placeholder="Nom du client *"
                  style={{ ..._inp, marginBottom: 7 }}
                />
                <input
                  value={cliForm.adr}
                  onChange={(e) => setCliForm((p) => ({ ...p, adr: e.target.value }))}
                  placeholder="Adresse"
                  style={{ ..._inp, marginBottom: 7 }}
                />
                <input
                  value={cliForm.npa}
                  onChange={(e) => setCliForm((p) => ({ ...p, npa: e.target.value }))}
                  placeholder="NPA / Ville"
                  style={{ ..._inp, marginBottom: 7 }}
                />
                <div style={{ display: 'flex', gap: 7, marginBottom: 8 }}>
                  <input
                    value={cliForm.tel}
                    onChange={(e) => setCliForm((p) => ({ ...p, tel: e.target.value }))}
                    placeholder="Téléphone"
                    style={{ ..._inp }}
                  />
                  <input
                    value={cliForm.email}
                    onChange={(e) => setCliForm((p) => ({ ...p, email: e.target.value }))}
                    placeholder="E-mail"
                    style={{ ..._inp }}
                  />
                </div>
                <Btn
                  label="✓ Créer le client"
                  color={C.green}
                  full
                  disabled={!cliForm.nom.trim()}
                  onClick={() => {
                    const nid = idProvisoire();
                    setClients((p) => [
                      ...p,
                      {
                        id: nid,
                        nom: cliForm.nom.trim(),
                        adr: cliForm.adr.trim(),
                        npa: cliForm.npa.trim(),
                        tel: cliForm.tel.trim(),
                        email: cliForm.email.trim(),
                        remiseGlobale: 0,
                        remises: {},
                      },
                    ]);
                    setForm((p) => ({ ...p, clientId: nid }));
                    setCliMode(null);
                    setNewCli('');
                    setCliForm({ nom: '', adr: '', npa: '', tel: '', email: '' });
                  }}
                />
              </div>
            )}
            {form.clientId && (
              <div style={{ marginTop: 12 }}>
                <BonCommandeClient
                  value={form.commandeClient}
                  onChange={(v) => setForm((p) => ({ ...p, commandeClient: v }))}
                  client={(clients || []).find((c) => c.id === form.clientId)}
                  setClients={setClients}
                />
                <EmailsOffre
                  value={form.emailsEnvoi}
                  onChange={(v) => setForm((p) => ({ ...p, emailsEnvoi: v }))}
                  client={(clients || []).find((c) => c.id === form.clientId)}
                />
              </div>
            )}
          </div>
        </Card>

        {/* Lignes */}
        <Card style={{ marginBottom: 11 }}>
          <Bar icon="📦" title={'Lignes (' + form.lignes.length + ')'} color={C.navy} />
          <div style={{ padding: 13 }}>
            <LignesEditor
              devisId={editId}
              form={form}
              setForm={setForm}
              catalogue={catalogue}
              setCatalogue={setCatalogue}
              stock={stock}
              clients={clients}
              estMag={estMixte ? univers === 'magasin' : soc?.secteur === 'magasin'}
              soc={soc}
              setSoc={setSoc}
              texteAssistant={dictee}
              setTexteAssistant={setDictee}
            />
            {/* Sans le Pack IA, la lecture d'une feuille de notes reste masquée. */}
            <OffreIa onOffre={repriseOffreIa} />

            {form.lignes.length > 0 && (
              <div style={{ marginTop: 11 }}>
                <div style={{ background: C.navy, borderRadius: 9, padding: '10px 12px' }}>
                  {form.remisePct > 0 && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '2px 0',
                        fontSize: 9.5,
                        color: 'rgba(255,255,255,.7)',
                      }}
                    >
                      <span>Total HT</span>
                      <span>
                        {DEVISE} {fmt(ht + remM)}
                      </span>
                    </div>
                  )}
                  {form.remisePct > 0 && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '2px 0',
                        fontSize: 9.5,
                        color: 'rgba(255,255,255,.7)',
                      }}
                    >
                      <span>Remise {pourcentLisible(form.remisePct)}%</span>
                      <span>
                        − {DEVISE} {fmt(remM)}
                      </span>
                    </div>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '2px 0',
                      fontSize: 9.5,
                      color: 'rgba(255,255,255,.7)',
                    }}
                  >
                    <span>{form.remisePct > 0 ? 'Total HT après remise' : 'Total HT'}</span>
                    <span>
                      {DEVISE} {fmt(ht)}
                    </span>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '2px 0',
                      fontSize: 9.5,
                      color: 'rgba(255,255,255,.7)',
                    }}
                  >
                    <ChoixTauxTva
                      soc={soc}
                      date={form.date}
                      value={form.tvaPct}
                      onChange={(t) => setForm((p) => ({ ...p, tvaPct: t }))}
                    />
                    <span>
                      {DEVISE} {fmt(tva)}
                    </span>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      paddingTop: 6,
                      marginTop: 4,
                      borderTop: '1px solid rgba(255,255,255,.2)',
                      fontSize: 13,
                      fontWeight: 900,
                      color: '#fff',
                    }}
                  >
                    <span>Total TTC</span>
                    <span>
                      {DEVISE} {fmt(ttc)}
                    </span>
                  </div>
                  {form.acompte > 0 && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingTop: 5,
                        fontSize: 9.5,
                        color: '#FCD34D',
                      }}
                    >
                      <span>{libelleAcompte(form)}</span>
                      <span>
                        {DEVISE} {fmt(aAmt)}
                      </span>
                    </div>
                  )}
                </div>
                {estMag && voitLeBenefice() && (
                  <MargePiece
                    lignes={form.lignes}
                    stock={stock}
                    remisePct={form.remisePct}
                    tvaPct={form.tvaPct}
                  />
                )}
              </div>
            )}
          </div>
        </Card>

        {/* Description + conditions */}
        <Card style={{ marginBottom: 11 }}>
          <Bar icon="📝" title="Description & conditions" />
          <div style={{ padding: 13 }}>
            {/* Plaque et véhicule : seulement pour un garage (ou une offre qui
                les porte déjà). Un magasin ordinaire ne les voyait pas venir. */}
            {estMag &&
              (/garage|auto/i.test(String(soc?.metier || '')) || form.plaque || form.vehicule) && (
                <>
                  <Inp
                    label="🚗 Plaque du véhicule (garage — optionnel)"
                    value={form.plaque || ''}
                    onChange={(e) => setForm((p) => ({ ...p, plaque: e.target.value }))}
                    placeholder="VD 123 456"
                  />
                  <Inp
                    label="🚗 Véhicule (marque / modèle / année)"
                    value={form.vehicule || ''}
                    onChange={(e) => setForm((p) => ({ ...p, vehicule: e.target.value }))}
                    placeholder="VW Golf 2.0 TDI — 2019"
                  />
                </>
              )}
            {/* Date et délai côte à côte, puis acompte et remise : tout tient
                sur deux lignes. Les textes (description, messages) sont repliés
                tant qu'on ne les remplit pas. */}
            <div style={{ display: 'flex', gap: 10 }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <Inp
                  label="Date"
                  value={form.date}
                  onChange={(e) => setForm((p) => ({ ...p, date: e.target.value }))}
                />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <Inp
                  label={estMag ? 'Délai de livraison' : "Délai d'exécution"}
                  value={form.delai}
                  placeholder={estMag ? 'ex. 2–3 jours' : 'ex. 2 semaines'}
                  onChange={(e) => setForm((p) => ({ ...p, delai: e.target.value }))}
                />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 12, marginTop: 4 }}>
              <ChampAcompte
                label="Acompte à la commande"
                pourcent={form.acompte || 0}
                montant={form.acompteMontant ?? null}
                enFrancs={!!form.acompteEnFrancs}
                ttc={ttc}
                calcule={aAmt}
                onChange={(v) => setForm((x) => ({ ...x, ...v }))}
              />
              <ChampPourcent
                label="Remise globale"
                value={form.remisePct || 0}
                // Vide tant qu'aucune remise globale n'est donnée : au magasin,
                // ce sont les remises par article du client qui comptent.
                placeholder=""
                videSiZero
                onChange={(n) => setForm((x) => ({ ...x, remisePct: n }))}
              />
            </div>
            <TexteReplie
              label={estMag ? 'Description' : 'Description des travaux'}
              rows={3}
              value={form.desc}
              onChange={(e) => setForm((p) => ({ ...p, desc: e.target.value }))}
            />
            <TexteReplie
              label={
                form.bonCommande
                  ? 'Message au sous-traitant (s’affiche en haut du bon)'
                  : termes.feminin
                    ? "Message au client (s'affiche en haut de l'offre)"
                    : "Message au client (s'affiche en haut du devis)"
              }
              rows={2}
              value={form.intro || ''}
              onChange={(e) => setForm((p) => ({ ...p, intro: e.target.value }))}
              styleTexte={styleDuMessage(form.stylesMessages, 'haut')}
              outil={
                <CouleurMessage
                  styles={form.stylesMessages}
                  quel="haut"
                  onChange={(v) => setForm((p) => ({ ...p, stylesMessages: v }))}
                />
              }
            />
            <TexteReplie
              label="Message en bas du document (sous vos coordonnées)"
              rows={2}
              placeholder={
                estMag
                  ? 'Ex. : Livraison prévue la semaine 45, retrait au dépôt.'
                  : 'Ex. : Travaux prévus la semaine 45, accès par l’entrée de service.'
              }
              value={form.piedMessage || ''}
              onChange={(e) => setForm((p) => ({ ...p, piedMessage: e.target.value }))}
              styleTexte={styleDuMessage(form.stylesMessages, 'bas')}
              outil={
                <CouleurMessage
                  styles={form.stylesMessages}
                  quel="bas"
                  onChange={(v) => setForm((p) => ({ ...p, stylesMessages: v }))}
                />
              }
            />
          </div>
        </Card>

        {/* Modèles de chantier */}
        <Card style={{ marginBottom: 11 }}>
          <div
            style={{
              background: '#f0fdf4',
              border: '1px solid #bbf7d0',
              borderRadius: 11,
              padding: 12,
              marginBottom: 12,
            }}
          >
            <div style={{ fontSize: 11.5, fontWeight: 800, color: '#166534', marginBottom: 3 }}>
              {estMag ? '📦 Modèles' : '📦 Modèles de chantier'}
            </div>
            <div style={{ fontSize: 9, color: '#16a34a', marginBottom: 8, lineHeight: 1.4 }}>
              {estMag
                ? "Charge une offre type (toutes les lignes d'un coup), ou enregistre les lignes actuelles comme modèle réutilisable."
                : "Charge un chantier type (toutes les lignes d'un coup), ou enregistre les lignes actuelles comme modèle réutilisable."}
            </div>
            {modeles.length > 0 ? (
              <>
                <div
                  onClick={() => setVoirModeles((v) => !v)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                    background: '#f0fdf4',
                    border: '1px solid #16a34a55',
                    borderRadius: 9,
                    padding: 11,
                    cursor: 'pointer',
                    fontSize: 11,
                    fontWeight: 800,
                    color: '#166534',
                    marginBottom: 8,
                  }}
                >
                  📂 Charger un modèle ({modeles.length}){' '}
                  <span style={{ fontSize: 9, opacity: 0.7 }}>{voirModeles ? '▲' : '▼'}</span>
                </div>
                {voirModeles && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
                    {modeles.map((m, i) => (
                      <span
                        key={i}
                        onClick={() => chargeModele(m)}
                        style={{
                          background: '#fff',
                          border: '1px solid #16a34a',
                          borderRadius: 8,
                          padding: '7px 11px',
                          fontSize: 11,
                          fontWeight: 700,
                          color: '#166534',
                          cursor: 'pointer',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 6,
                        }}
                      >
                        📦 {m.nom}
                      </span>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <div style={{ fontSize: 9, color: '#94a3b8', marginBottom: 8 }}>
                Aucun modèle enregistré pour l&apos;instant.
              </div>
            )}
            {(form.lignes || []).length > 0 && (
              <span
                onClick={enregistreModele}
                style={{
                  display: 'inline-block',
                  background: '#166534',
                  color: '#fff',
                  borderRadius: 8,
                  padding: '8px 13px',
                  fontSize: 11,
                  fontWeight: 800,
                  cursor: 'pointer',
                }}
              >
                💾 Enregistrer ces lignes comme modèle
              </span>
            )}
          </div>
        </Card>

        {!estMag && (
          <Card style={{ marginBottom: 11 }}>
            <Bar
              icon="📷"
              title="Photos / pièces jointes"
              color={C.purple}
              sub={
                termes.feminin
                  ? 'Photo, justificatif ou facture liée à cette offre (facultatif)'
                  : 'Photo, justificatif ou facture liée à ce devis (facultatif)'
              }
            />
            <div style={{ padding: 13 }}>
              {/*
                Elles partent au serveur des le depot : elles vivaient jusqu'ici
                dans l'etat de l'ecran, et les perdre revenait a ne plus pouvoir
                verifier la marge apres coup. Sur un devis neuf, elles attendent
                sa creation (lib/pieces-attente.js).
              */}
              <FacturesJointes
                documentId={editId}
                categories={metierCats(soc, estMag)}
                brouillons={piecesBrouillon}
                onBrouillons={setPiecesBrouillon}
              />
            </div>
          </Card>
        )}

        {editId && (
          <div style={{ marginTop: 9, marginBottom: 6 }}>
            {!confDel ? (
              <Btn
                label={'🗑 ' + termes.supprimer}
                ghost
                color={C.red}
                full
                onClick={() => setConfDel(true)}
              />
            ) : (
              <div
                style={{
                  background: C.redL,
                  border: '1px solid ' + C.red,
                  borderRadius: 11,
                  padding: 11,
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 800,
                    color: C.red,
                    marginBottom: 8,
                    textAlign: 'center',
                  }}
                >
                  {termes.feminin
                    ? 'Supprimer définitivement cette offre ?'
                    : 'Supprimer définitivement ce devis ?'}
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <Btn
                    label="Annuler"
                    sm
                    ghost
                    color={C.grey}
                    full
                    onClick={() => setConfDel(false)}
                  />
                  <Btn
                    label="Oui, supprimer"
                    sm
                    color={C.red}
                    full
                    onClick={() => {
                      setDevis((p) => p.filter((x) => x.id !== editId));
                      setConfDel(false);
                      setEditId(null);
                      setView('liste');
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        )}
        <div
          style={{
            position: 'sticky',
            bottom: 0,
            marginTop: 10,
            marginLeft: -13,
            marginRight: -13,
            paddingLeft: 13,
            paddingRight: 13,
            paddingTop: 10,
            paddingBottom: 10,
            background: C.white,
            borderTop: '1px solid ' + C.border,
            boxShadow: '0 -6px 16px rgba(15,23,42,.10)',
            zIndex: 8,
          }}
        >
          <Btn
            label={
              editId
                ? '✓ Enregistrer les modifications'
                : form.bonCommande
                  ? '✓ Générer le bon de commande'
                  : '✓ ' + termes.generer
            }
            // Un bouton désactivé sans explication laissait croire à une
            // panne : il reste actif, grisé, et dit ce qui manque.
            color={
              !form.clientId || form.lignes.length === 0 || ligneSansTitre ? '#94A3B8' : C.green
            }
            full
            onClick={() => {
              // Les travaux écrits dans l'assistant, sans « Trouver les
              // articles + remplir » : le devis restait à zéro ligne et le
              // bouton refusait sans que l'on comprenne pourquoi.
              if (form.lignes.length === 0 && dictee.trim()) {
                // Une offre déjà rédigée, prix compris : elle devient l'offre
                // d'un seul geste, sans repasser par les lignes.
                const redigee = litUneOffreRedigee(dictee, { batiment: !estMag });
                if (redigee && form.clientId && redigee.every((l) => l.p > 0)) {
                  const lignes = redigee.map((l) => ({ ...l, id: uid() }));
                  setForm((p) => ({ ...p, lignes }));
                  setDictee('');
                  generer(lignes);
                  return;
                }
                litLaDictee(true);
                return;
              }
              const manque = ceQuiManque();
              if (manque) {
                alert(manque);
                return;
              }
              generer();
            }}
          />
          {(!form.clientId || form.lignes.length === 0) && (
            <div style={{ fontSize: 8, color: C.muted, textAlign: 'center', marginTop: 6 }}>
              {form.lignes.length === 0 && dictee.trim()
                ? 'Touche « Générer » : tes travaux écrits dans l’assistant deviennent des lignes.'
                : form.bonCommande
                  ? 'Choisis le sous-traitant et ajoute au moins une ligne.'
                  : 'Choisis un client et ajoute au moins une ligne.'}
            </div>
          )}
          {form.clientId && ligneSansTitre && (
            <div
              role="status"
              style={{ fontSize: 8, color: C.red, textAlign: 'center', marginTop: 6 }}
            >
              Donnez un titre à chaque ligne avant d’enregistrer.
            </div>
          )}
        </div>
      </Shell>
    );
  }

  /* DÉTAIL */
  if (view === 'detail' && selD) {
    const cl = clients.find((c) => c.id === selD.clientId);
    const mod = MODELES.find((m) => m.id === selD.modeleId);
    // Le detail oubliait la remise globale sur le hors taxe tout en la
    // retenant sur la TVA : il annoncait un total que le PDF ne portait pas.
    const {
      ht: dHT,
      tva: dTVA,
      ttc: dTTC,
      remise: dRemise,
    } = totauxDocument(selD.lignes, selD.tvaPct, selD.remisePct);
    const dAcp = acompteDocument(
      selD.lignes,
      selD.tvaPct,
      selD.remisePct,
      selD.acompte,
      selD.acompteMontant,
    );
    const lieuAuto = (() => {
      const c = chantierLie(selD, chantiers);
      return c ? [c.adr, c.npa].filter(Boolean).join(', ') : '';
    })();
    return (
      <Shell
        active="devis"
        onNav={onNav}
        soc={soc}
        back
        onBack={() => setView('liste')}
        pageTitle={selD.num || selD.id}
        estMixte={estMixte}
        univers={univers}
        setUnivers={setUnivers}
      >
        {menuEnvoi && (
          <MenuEnvoi
            piece={selD}
            nature={termes.Mot}
            client={(clients || []).find((c) => c.id === selD.clientId)}
            soc={soc}
            onClose={() => setMenuEnvoi(false)}
            notePartage={{ type: 'DEVIS', id: selD.id }}
            onEnvoye={() => setTimeout(() => setVersionEnvoi((v) => v + 1), 800)}
            lienType="devis"
            cheminPdf={cheminPdfD}
            versionPdf={versionPdfD}
            envoiServeur={
              Number.isInteger(selD.id) && selD.statut !== 'Brouillon'
                ? (choix) => envoisApi.envoieDevis(selD.id, choix?.attestations)
                : null
            }
            // « 📎 Joindre des attestations » : RC, registre du commerce…, pour
            // qui a le droit de les voir (Réglages → Accès).
            joindreAttestations={voitLesAttestations(soc?.permAttestations)}
            cibleServeur={adressesDeLOffre(
              (clients || []).find((c) => c.id === selD.clientId),
              selD.emailsEnvoi,
            ).join(', ')}
            avertissement={avertissementIban({
              soc,
              piece: selD,
              montant: dAcp,
              quoi: 'l’acompte',
              onNav,
              refait: true,
            })}
            serveurIndisponible={
              !Number.isInteger(selD.id)
                ? termes.feminin
                  ? 'Enregistre l’offre pour que SwissTech puisse l’envoyer avec son PDF.'
                  : 'Enregistre le devis pour que SwissTech puisse l’envoyer avec son PDF.'
                : selD.statut === 'Brouillon'
                  ? termes.feminin
                    ? 'Sors l’offre du brouillon pour que SwissTech puisse l’expédier avec son PDF.'
                    : 'Sors le devis du brouillon pour que SwissTech puisse l’expédier avec son PDF.'
                  : ''
            }
          />
        )}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3,1fr)',
            gap: 8,
            marginBottom: 13,
          }}
        >
          {[
            [
              '✎',
              'Modifier',
              () => {
                // Une offre acceptée se modifie encore ; si son contenu change,
                // la signature du client ne vaut plus pour la nouvelle version.
                if (selD.statut === 'Accepté') {
                  // Déjà facturée (acompte, avancement) : les factures émises
                  // ne bougent pas, la finale reprendra la nouvelle version.
                  const emises = (factures || []).filter(
                    (f) =>
                      String(f.devisId) === String(selD.id) &&
                      f.statut !== 'Brouillon' &&
                      f.statut !== 'Annulée',
                  );
                  const avis = emises.length
                    ? tr(AVIS_OFFRE_SIGNEE) +
                      '\n\n' +
                      trf(AVIS_OFFRE_FACTUREE, emises.map((f) => f.num || f.id).join(', '))
                    : tr(AVIS_OFFRE_SIGNEE);
                  if (!window.confirm(avis)) return;
                }
                startEdit(selD);
              },
              C.navy,
            ],
            // Le vrai PDF de l'offre, celui que le client reçoit : un aperçu
            // tant qu'elle est un brouillon.
            [
              '📄',
              'PDF',
              () => {
                if (!Number.isInteger(selD.id)) {
                  setView('doc');
                  return;
                }
                ouvreDocument(
                  selD.statut === 'Brouillon'
                    ? `/devis/${selD.id}/document/apercu`
                    : `/devis/${selD.id}/document`,
                ).catch((e) => {
                  // Déjà montrée dans la visionneuse : pas une seconde fois.
                  if (!e?.dejaAffiche) {
                    window.alert(e?.message || tr("Le PDF n'a pas pu être produit."));
                  }
                });
              },
              C.teal,
            ],
            ['📤', 'Envoyer', () => setMenuEnvoi(true), C.green],
          ].map(([ic, lb, fn, col]) => (
            <button
              key={lb}
              onClick={fn}
              style={{
                border: 'none',
                borderRadius: 13,
                padding: '15px 6px',
                background: col,
                color: '#fff',
                fontSize: 11.5,
                fontWeight: 800,
                cursor: 'pointer',
                lineHeight: 1.5,
                boxShadow: '0 2px 8px rgba(0,0,0,.12)',
              }}
            >
              {ic}
              <br />
              {lb}
            </button>
          ))}
        </div>
        <DernierEnvoi type="DEVIS" id={selD.id} version={versionEnvoi} />

        <Card style={{ marginBottom: 11 }}>
          <div
            style={{
              background: C.white,
              padding: '12px 14px',
              borderBottom: '3px solid ' + (mod?.col || C.navy),
            }}
          >
            <div
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}
            >
              <div></div>
              <div style={{ textAlign: 'right' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: 6,
                  }}
                >
                  <div style={{ fontSize: 13, fontWeight: 900, color: C.ink }}>
                    {selD.num || selD.id}
                  </div>
                  <button
                    onClick={async () => {
                      const v = await demande(
                        termes.feminin
                          ? 'Numéro de l’offre (laisser vide = numéro automatique) :'
                          : 'Numéro du devis (laisser vide = numéro automatique) :',
                        selD.num || selD.id,
                      );
                      if (v !== null) {
                        const t = v.trim();
                        if (t && numeroPris(devis, t, selD.id)) {
                          alert(trf('Le numéro {0} est déjà utilisé par une autre offre.', t));
                          return;
                        }
                        // Envoyée ou signée, l'offre est chez le client.
                        if (
                          t !== (selD.num || String(selD.id)) &&
                          selD.statut !== 'Brouillon' &&
                          !window.confirm(tr(AVIS_NUMERO_OFFRE))
                        ) {
                          return;
                        }
                        setDevis((p) =>
                          p.map((x) =>
                            x.id === selD.id
                              ? { ...x, num: t && t !== selD.id ? t : undefined }
                              : x,
                          ),
                        );
                      }
                    }}
                    style={{
                      background: C.navyXL,
                      border: 'none',
                      borderRadius: 6,
                      padding: '3px 7px',
                      fontSize: 9,
                      fontWeight: 700,
                      color: C.navy,
                      cursor: 'pointer',
                    }}
                  >
                    ✏️
                  </button>
                </div>
                <div style={{ fontSize: 8, color: C.muted }}>{selD.date}</div>
                <div style={{ marginTop: 4 }}>
                  {(() => {
                    const etat = etatOffreSeule(selD, factures, chantiers);
                    return (
                      <Pill
                        label={etat}
                        color={
                          etat === 'Payé' || etat === 'Accepté'
                            ? C.green
                            : etat === 'Facturé'
                              ? C.teal
                              : etat === 'Refusé'
                                ? C.red
                                : C.amber
                        }
                        size={8}
                      />
                    );
                  })()}
                </div>
              </div>
            </div>
          </div>
          {cl && (
            <div
              style={{
                margin: '10px 14px',
                background: C.navyXL,
                borderRadius: 8,
                padding: '9px 11px',
              }}
            >
              <div style={{ fontSize: 7.5, color: C.muted, textTransform: 'uppercase' }}>
                Client
              </div>
              <div style={{ fontSize: 11, fontWeight: 700, color: C.ink }}>{cl.nom}</div>
              <div style={{ fontSize: 9, color: C.grey }}>
                {cl.adr} · {cl.npa}
              </div>
              {String(selD.commandeClient ?? '').trim() && (
                <div style={{ fontSize: 10, color: C.ink, marginTop: 5 }}>
                  🧾 {tr('Votre bon de commande :')} <b>{selD.commandeClient}</b>
                </div>
              )}
            </div>
          )}

          {selD.desc && (
            <div
              style={{
                margin: '0 14px 10px',
                background: C.warm,
                borderRadius: 8,
                padding: '9px 11px',
                fontSize: 9.5,
                color: C.grey,
                lineHeight: 1.5,
              }}
            >
              {selD.desc}
            </div>
          )}
          {/*
            Les pieces d'un devis vivent sur le serveur : ce bloc-ci les
            ajoutait dans l'etat de l'ecran seulement, et la photo du bon du
            fournisseur disparaissait au rechargement — alors que le bouton
            voisin, lui, appelait bien le serveur pour la retirer. C'est le
            meme composant que la saisie l'emploie, pour qu'il n'y ait qu'une
            facon d'attacher une piece a un devis.
          */}
          <div style={{ margin: '0 14px 10px' }}>
            <div
              style={{
                fontSize: 8,
                fontWeight: 800,
                color: C.muted,
                textTransform: 'uppercase',
                letterSpacing: 0.4,
                marginBottom: 6,
              }}
            >
              {tr('📎 Pièces jointes')}
            </div>
            <FacturesJointes
              documentId={selD.id}
              numero={selD.num ?? selD.id}
              categories={metierCats(soc, estMag)}
              variante="fiche"
            />
            {photosPlanche(selD).length > 0 && (
              <div style={{ marginTop: 7 }}>
                <Btn
                  label={'🖼 Voir / imprimer les photos en A4 (' + photosPlanche(selD).length + ')'}
                  ghost
                  color={C.teal}
                  full
                  onClick={() => setView('photos')}
                />
              </div>
            )}
          </div>
          <div ref={listRefD} style={{ padding: '0 14px 14px' }}>
            {(selD.lignes || []).map((l, rangL) => {
              const _op = openLine === l.id;
              const _dc = descLine === l.id;
              const _lg = (l.sd || '').length > 70;
              const _u = (k, v) =>
                setDevis((p) =>
                  p.map((d) =>
                    d.id === selD.id
                      ? {
                          ...d,
                          lignes: d.lignes.map((x) => (x.id === l.id ? { ...x, [k]: v } : x)),
                        }
                      : d,
                  ),
                );
              return (
                <div
                  key={l.id}
                  data-lid={l.id}
                  style={{
                    background: C.white,
                    border: '1px solid ' + (dragIdD === l.id ? C.teal : C.border),
                    borderRadius: 13,
                    padding: '12px 13px',
                    marginBottom: 9,
                    boxShadow:
                      dragIdD === l.id
                        ? '0 8px 22px rgba(15,22,38,.22)'
                        : '0 1px 3px rgba(15,22,38,.05)',
                  }}
                >
                  {/*
                    Le haut de l'article (son nom) et la poignée ☰ le prennent :
                    au doigt, après un appui long, l'article se soulève et se
                    déplace ; le doigt qui glisse aussitôt fait défiler l'offre,
                    pour lire les articles sans les bouger. À la souris, on le
                    tire. Un toucher bref l'ouvre.
                  */}
                  <div
                    onClick={() => {
                      if (vientDeGlisserD.current) return;
                      setOpenLine((prev) => (prev === l.id ? null : l.id));
                    }}
                    onPointerDown={(e) => rowDownD(e, l.id)}
                    onContextMenu={(e) => e.preventDefault()}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 10,
                      cursor: 'grab',
                      ...ZONE_APPUI_LONG,
                    }}
                  >
                    <div
                      onClick={(e) => e.stopPropagation()}
                      onPointerDown={(e) => {
                        e.stopPropagation();
                        rowDownD(e, l.id, true);
                      }}
                      title="Glisser pour déplacer"
                      style={{
                        flex: '0 0 auto',
                        width: 26,
                        height: 28,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: C.muted,
                        fontSize: 15,
                        cursor: 'grab',
                        touchAction: 'pan-y',
                        borderRadius: 7,
                        background: C.navyXL,
                      }}
                    >
                      ☰
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{ fontSize: 12.5, fontWeight: 800, color: C.ink, lineHeight: 1.3 }}
                      >
                        {l.d || '(article)'}
                      </div>
                      {l.sd && (
                        <div
                          style={{
                            fontSize: 10.5,
                            color: C.ink,
                            lineHeight: 1.45,
                            marginTop: 3,
                            ...(!_dc && _lg ? { maxHeight: 31, overflow: 'hidden' } : {}),
                          }}
                        >
                          {l.sd}
                        </div>
                      )}
                      {_lg && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            setDescLine(_dc ? null : l.id);
                          }}
                          style={{
                            fontSize: 10,
                            fontWeight: 700,
                            color: C.navy,
                            cursor: 'pointer',
                            marginTop: 2,
                            display: 'inline-block',
                          }}
                        >
                          {_dc ? 'Réduire ▲' : 'Plus… ▼'}
                        </span>
                      )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
                      {l.imgs && l.imgs.length > 0 && !_op ? (
                        <span
                          style={{
                            fontSize: 7.5,
                            fontWeight: 800,
                            color: C.teal,
                            background: C.tealL,
                            borderRadius: 20,
                            padding: '2px 7px',
                          }}
                        >
                          📎 {l.imgs.length}
                        </span>
                      ) : null}
                      <span style={{ color: C.muted, fontSize: 13 }}>{_op ? '▲' : '✎'}</span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: 9,
                      paddingTop: 9,
                      borderTop: '1px dashed ' + C.border,
                    }}
                  >
                    <div style={{ fontSize: 11, color: C.grey, fontWeight: 600 }}>
                      {estBloc(l)
                        ? tr('Prix global')
                        : l.q + ' × ' + DEVISE + ' ' + fmt(prixApplique(l)) + ' / ' + (l.u || 'u')}
                      {(+l.rem || 0) > 0 ? ' · -' + l.rem + '%' : ''}
                    </div>
                    <div style={{ fontSize: 14, fontWeight: 900, color: C.ink }}>
                      {DEVISE} {fmt((+l.q || 0) * prixApplique(l) * (1 - (+l.rem || 0) / 100))}
                    </div>
                  </div>
                  {_op && (
                    <div
                      style={{ marginTop: 10, borderTop: '1px dashed ' + C.border, paddingTop: 10 }}
                    >
                      <div style={{ marginBottom: 11 }}>
                        <MediasLigne
                          devisId={selD.id}
                          cle={l.cle}
                          medias={l.imgs}
                          onChange={(v) => _u('imgs', v)}
                        />
                      </div>
                      {/* Bâtiment : d'abord de quoi il s'agit (« Plafond, salle de
                          bain »), puis ce qu'on y fait (« Préparation du plafond,
                          masticage, ponçage, prêt à peindre »). */}
                      <ChampDesignation
                        value={l.d}
                        rang={rangL + 1}
                        onChange={(v) => _u('d', v)}
                        label={estMag ? 'Désignation' : 'Désignation — de quoi il s’agit'}
                        placeholder={estMag ? undefined : tr('ex. Plafond, salle de bain')}
                      />
                      <Inp label={estMag ? 'Description' : 'Description — ce qu’on fait'}>
                        <ChampDescription
                          value={l.sd || ''}
                          onChange={(v) => _u('sd', v)}
                          placeholder={
                            estMag
                              ? 'Détails (optionnel)'
                              : tr('ex. Préparation du plafond, masticage, ponçage, prêt à peindre')
                          }
                        />
                      </Inp>
                      <div style={{ display: 'flex', gap: 7 }}>
                        <div style={{ flex: 1 }}>
                          <Inp
                            label="Quantité"
                            type="text"
                            value={l.q}
                            onChange={(e) => _u('q', e.target.value.replace(',', '.'))}
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <ChampUnite
                            value={l.u}
                            onChange={(u) => _u('u', u)}
                            unites={metierUnites(soc, estMag)}
                            placeholder={estMag ? 'pièce, bouteille, pack…' : 'm², pce, h…'}
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Inp
                            label={'Prix ' + DEVISE}
                            type="text"
                            value={l.p}
                            onChange={(e) => _u('p', e.target.value.replace(',', '.'))}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginTop: 2,
                        }}
                      >
                        <button
                          onClick={() => {
                            setDevis((p) =>
                              p.map((d) =>
                                d.id === selD.id
                                  ? { ...d, lignes: d.lignes.filter((x) => x.id !== l.id) }
                                  : d,
                              ),
                            );
                            setOpenLine(null);
                          }}
                          style={{
                            background: C.redL,
                            border: 'none',
                            borderRadius: 8,
                            color: C.red,
                            padding: '8px 12px',
                            fontSize: 11,
                            fontWeight: 700,
                            cursor: 'pointer',
                          }}
                        >
                          🗑 Supprimer
                        </button>
                        <button
                          onClick={() => setOpenLine(null)}
                          style={{
                            background: C.navy,
                            border: 'none',
                            borderRadius: 8,
                            color: '#fff',
                            padding: '8px 16px',
                            fontSize: 11,
                            fontWeight: 800,
                            cursor: 'pointer',
                          }}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            <div style={{ marginTop: 10 }}>
              {selD.remisePct > 0 && (
                <>
                  <FR label={'Total HT'} value={DEVISE + ' ' + fmt(dHT + dRemise)} />
                  <FR
                    label={'Remise ' + pourcentLisible(selD.remisePct) + '%'}
                    value={'− ' + DEVISE + ' ' + fmt(dRemise)}
                  />
                </>
              )}
              <FR
                label={selD.remisePct > 0 ? 'Total HT après remise' : 'Sous-total HT'}
                value={DEVISE + ' ' + fmt(dHT)}
              />
              <FR
                label={
                  totauxDocument(selD.lignes, selD.tvaPct, selD.remisePct).multi
                    ? 'TVA (plusieurs taux)'
                    : 'TVA ' + (selD.tvaPct ?? TAUX_LEGAUX_ACTUELS.normal) + '%'
                }
                value={DEVISE + ' ' + fmt(dTVA)}
              />
            </div>
            <div
              style={{
                background: mod?.col || C.navy,
                borderRadius: 8,
                padding: '9px 12px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: 6,
              }}
            >
              <span style={{ fontSize: 10, fontWeight: 700, color: '#fff' }}>Total TTC</span>
              <span style={{ fontSize: 15, fontWeight: 900, color: '#fff' }}>
                {DEVISE} {fmt(dTTC)}
              </span>
            </div>
            {selD.acompte > 0 && (
              <div
                style={{
                  background: C.amberL,
                  border: '1px solid ' + C.amber + '30',
                  borderRadius: 8,
                  padding: '8px 11px',
                  marginTop: 8,
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontSize: 10,
                }}
              >
                <span style={{ color: C.amber, fontWeight: 700 }}>{libelleAcompte(selD)}</span>
                <span style={{ fontWeight: 800, color: C.amber }}>
                  {DEVISE} {fmt(dAcp)}
                </span>
              </div>
            )}
            {selD.acompte > 0 && (
              <div
                style={{
                  background: C.navyXL,
                  borderRadius: 8,
                  padding: '8px 11px',
                  marginTop: 6,
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontSize: 10,
                }}
              >
                <span style={{ color: C.grey, fontWeight: 700 }}>
                  {+selD.acompteMontant > 0
                    ? 'Reste à payer'
                    : 'Reste à payer (' + (100 - (selD.acompte || 0)) + '%)'}
                </span>
                <span style={{ fontWeight: 800, color: C.ink }}>
                  {DEVISE} {fmt(dTTC - dAcp)}
                </span>
              </div>
            )}
          </div>
        </Card>

        {selD.statut === 'Accepté' && (
          <div
            style={{
              background: C.greenL,
              border: '1px solid ' + C.green + '30',
              borderRadius: 10,
              padding: '11px 13px',
              marginTop: 8,
            }}
          >
            <div style={{ fontSize: 11, fontWeight: 800, color: C.green }}>
              {'✓ ' + termes.Accepte}
            </div>
            <div style={{ fontSize: 9, color: C.grey, marginTop: 2 }}>
              {chantierDuDevis(selD, chantiers) ? 'Chantier créé · signé le ' : 'Signée le '}
              {selD.signDate}
              {signatureDuClient(selD)?.heure ? ' à ' + signatureDuClient(selD).heure : ''}
            </div>
            {/* La signature que le client a tracée sur son lien ou la
                tablette, avec son nom : la preuve de son accord. */}
            {signatureDuClient(selD) && (
              <div
                data-testid="signature-client"
                style={{
                  background: C.white,
                  border: '1px solid ' + C.border,
                  borderRadius: 8,
                  padding: '6px 8px',
                  marginTop: 7,
                }}
              >
                <div style={{ fontSize: 8, color: C.muted, fontWeight: 700 }}>
                  {trf('Signée par {0}', signatureDuClient(selD).nom || '—')}
                </div>
                {signatureDuClient(selD).trace && (
                  <svg
                    viewBox="0 0 320 130"
                    role="img"
                    aria-label="Signature du client"
                    style={{ width: '100%', maxWidth: 260, height: 'auto', display: 'block' }}
                  >
                    <path
                      d={signatureDuClient(selD).trace}
                      fill="none"
                      stroke={C.navy}
                      strokeWidth="2.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </div>
            )}
            <div style={{ fontSize: 9, color: C.grey, marginTop: 4, lineHeight: 1.45 }}>
              {tr(AVIS_OFFRE_SIGNEE)}
            </div>
            {/* Une offre du bâtiment acceptée sans chantier (acceptée avant que
                le serveur ne l'ouvre, ou établie sous le magasin d'un Mix) :
                le patron l'ouvre d'un geste. */}
            {!estMag && typeof selD.id === 'number' && !chantierDuDevis(selD, chantiers) && (
              <div style={{ marginTop: 9 }}>
                <Btn
                  label="🏗️ Ouvrir le chantier"
                  color={C.green}
                  full
                  onClick={async () => {
                    try {
                      await devisApi.ouvreChantier(selD.id);
                      if (rechargeChantiers) await rechargeChantiers();
                    } catch (e) {
                      alert(e?.message || "Le chantier n'a pas pu être ouvert.");
                    }
                  }}
                />
              </div>
            )}
            {selD.acompte > 0 &&
              (selD.acompteFacture ? (
                (() => {
                  // La facture d'acompte ne se range dans Factures qu'une fois
                  // payée : jusque-là, elle s'ouvre et s'envoie d'ici.
                  const fa = factures.find(
                    (f) =>
                      f.type === 'acompte' &&
                      f.statut !== 'Annulée' &&
                      String(f.devisId) === String(selD.id),
                  );
                  const payee = fa && !acompteEnAttente(fa);
                  return (
                    <div style={{ marginTop: 8 }}>
                      <div style={{ fontSize: 9.5, fontWeight: 700, color: C.teal }}>
                        {payee
                          ? '✓ ' +
                            trf(
                              'Acompte payé — facture n° {0}, dans Factures.',
                              selD.acompteFacture,
                            )
                          : '⏳ ' +
                            trf(
                              'Acompte en attente de paiement (facture n° {0}). Elle apparaîtra dans Factures dès que l’acompte sera payé.',
                              selD.acompteFacture,
                            )}
                        {termes.feminin
                          ? ' Le QR de l’offre porte sa référence.'
                          : ' Le QR du devis porte sa référence.'}
                      </div>
                      {fa && (
                        <div style={{ marginTop: 6 }}>
                          <Btn
                            label={
                              payee
                                ? '🧾 ' + tr('Voir la facture d’acompte')
                                : '🧾 ' + tr('Voir, envoyer ou encaisser l’acompte')
                            }
                            ghost
                            color={C.teal}
                            full
                            onClick={() => onNav('factures', { factureId: fa.id })}
                          />
                        </div>
                      )}
                    </div>
                  );
                })()
              ) : (
                <div style={{ marginTop: 9 }}>
                  <Btn
                    label={'💰 ' + libelleAcompte(selD) + ' → générer la facture'}
                    color={C.green}
                    full
                    onClick={async () => {
                      // Une offre enregistree : le serveur etablit la facture
                      // d'acompte, ou rend celle qu'il a deja etablie a
                      // l'acceptation. Jamais une seconde.
                      if (typeof selD.id === 'number') {
                        try {
                          const f = await devisApi.factureAcompte(selD.id);
                          if (rechargeFactures) await rechargeFactures();
                          if (rechargeDevis) await rechargeDevis();
                          else
                            setDevis((p) =>
                              p.map((x) =>
                                x.id === selD.id ? { ...x, acompteFacture: f.numero } : x,
                              ),
                            );
                          alert(
                            trf(
                              'Facture d’acompte n° {0} prête. Elle apparaîtra dans Factures dès que l’acompte sera payé ; d’ici, tu peux déjà l’ouvrir et l’envoyer.',
                              f.numero,
                            ),
                          );
                        } catch (e) {
                          alert(e?.message || "La facture d'acompte n'a pas pu être établie.");
                        }
                        return;
                      }
                      const cl = clients.find((c) => c.id === selD.clientId);
                      const htD = (selD.lignes || []).reduce(
                        (s, l) => s + (+l.q || 0) * prixApplique(l) * (1 - (l.rem || 0) / 100),
                        0,
                      );
                      const acHT = Math.round(((htD * (selD.acompte || 0)) / 100) * 100) / 100;
                      const numF = nextSeq(factures);
                      const chA = chantierDuDevis(selD, chantiers);
                      setFactures((p) => [
                        {
                          id: numF,
                          type: 'acompte',
                          devisId: selD.id,
                          chantierId: chA ? chA.id : selD.chantierId || '',
                          siteId: typeof chA?.id === 'number' ? chA.id : (selD.siteId ?? null),
                          desc: selD.desc || '',
                          clientId: selD.clientId,
                          date: today(),
                          echeance: '30 jours',
                          tvaPct: selD.tvaPct ?? TAUX_LEGAUX_ACTUELS.normal,
                          statut: 'Envoyée',
                          paidDate: null,
                          envoye: true,
                          envoyeLe: today(),
                          lignes: [
                            {
                              id: uid(),
                              d: trf(
                                'Acompte {0}% — {1} n° {2}',
                                selD.acompte,
                                motDocument(termes),
                                selD.num || selD.id,
                              ),
                              q: 1,
                              u: 'forfait',
                              p: acHT,
                              rem: 0,
                            },
                          ],
                          sect: estMag ? 'magasin' : 'batiment',
                        },
                        ...p,
                      ]);
                      setDevis((p) =>
                        p.map((x) => (x.id === selD.id ? { ...x, acompteFacture: numF } : x)),
                      );
                      alert(
                        "Facture d'acompte " +
                          numF +
                          " générée et marquée envoyée. Tu peux la partager depuis l'écran Factures.",
                      );
                    }}
                  />
                </div>
              ))}
            {/* Le client a accepté sans le vouloir : le patron remet l'offre
                refusée. Réservé au patron, comme la suppression d'une offre
                acceptée. */}
            {estPatron && typeof selD.id === 'number' && (
              <div style={{ marginTop: 10 }}>
                <Btn
                  label={tr('↩ Le client a refusé (annuler l’acceptation)')}
                  ghost
                  danger
                  full
                  onClick={() => annulerLAcceptation(selD)}
                />
              </div>
            )}
          </div>
        )}
        {estMag && voitLeBenefice() && (
          <MargePiece
            lignes={selD.lignes}
            stock={stock}
            remisePct={selD.remisePct}
            tvaPct={selD.tvaPct}
          />
        )}
        {selD.statut !== 'Accepté' && selD.statut !== 'Refusé' && (
          <div style={{ marginTop: 9 }}>
            {/*
              L'ecran de signature existait, avec sa valeur legale
              d'acceptation, mais rien n'y menait : aucun devis ne pouvait
              donc etre accepte, et le module des chantiers — ou un chantier
              nait d'un devis accepte — restait vide a jamais.

              C'est le geste du terrain : on tend la tablette au client, qui
              signe sur place.
            */}
            {/* « Faire signer le client » est retiré à la demande du patron : le
                client signe par son lien. Reste le oui donné de vive voix ou
                par téléphone, sans quoi l'offre ne pouvait plus être acceptée
                ni ouvrir son chantier. */}
            <Btn
              label="✓ Le client a accepté"
              color={C.green}
              full
              onClick={() => {
                if (!window.confirm(tr('Marquer cette offre comme acceptée par le client ?')))
                  return;
                accepter(selD, '');
              }}
            />
            {/* Le non dit de vive voix ou par téléphone : le client n'a rien
                touché à son lien, le patron le note lui-même. */}
            <div style={{ marginTop: 9 }}>
              <Btn
                label="✗ Le client a refusé"
                color={C.red}
                ghost
                full
                onClick={() => {
                  if (!window.confirm(tr('Marquer cette offre comme refusée par le client ?')))
                    return;
                  refuser(selD);
                }}
              />
            </div>
          </div>
        )}
        <div style={{ marginTop: 9 }}>
          {(() => {
            // Déjà facturée : le bouton mène à la facture, il n'en refait pas.
            const deja = (factures || []).find(
              (f) =>
                f.devisId === selD.id &&
                f.type !== 'acompte' &&
                f.type !== 'avoir' &&
                f.statut !== 'Annulée',
            );
            return deja ? (
              <Btn
                label={trf('🧾 Voir la facture {0}', deja.num || deja.id)}
                color={C.teal}
                ghost
                full
                onClick={() => onNav('factures', { factureId: deja.id })}
              />
            ) : (
              <Btn
                label="🧾 Convertir en facture"
                color={C.teal}
                full
                onClick={() => convertirFacture(selD)}
              />
            );
          })()}
        </div>
        {selD.statut === 'En attente' && (
          <RelanceOffre offre={selD} reglages={relanceAuto} version={versionEnvoi} onNav={onNav} />
        )}
        {selD.statut === 'Refusé' && (
          <div
            style={{
              background: C.redL,
              border: '1px solid ' + C.red + '30',
              borderRadius: 10,
              padding: '11px 13px',
              marginTop: 8,
            }}
          >
            <div style={{ fontSize: 11, fontWeight: 800, color: C.red }}>✕ {termes.Refuse}</div>
            <div style={{ fontSize: 9, color: C.grey, marginTop: 2 }}>
              {selD.refuseLe
                ? 'Le client a refusé le ' + selD.refuseLe + '.'
                : 'Le client a refusé.'}
            </div>
            {selD.motifRefus && (
              <div style={{ fontSize: 9.5, color: C.ink, marginTop: 6, lineHeight: 1.5 }}>
                <b>Motif :</b> {selD.motifRefus}
              </div>
            )}
            <div style={{ fontSize: 8.5, color: C.muted, marginTop: 6, lineHeight: 1.5 }}>
              {termes.feminin
                ? 'Tu peux relancer le client par son lien ci-dessous, ou repartir de cette offre pour en proposer une nouvelle.'
                : 'Tu peux relancer le client par son lien ci-dessous, ou repartir de ce devis pour en proposer un nouveau.'}
            </div>
            {/* Le client a dit oui après son refus, de vive voix ou au
                téléphone : le patron l'accepte d'un geste (« il y a pas tous
                les clients qui savent utiliser » le lien). Chantier et
                acompte suivent comme pour toute acceptation. */}
            {estPatron && typeof selD.id === 'number' && (
              <div style={{ marginTop: 8 }}>
                <Btn
                  label="✓ Le client a accepté"
                  sm
                  color={C.green}
                  full
                  onClick={() => {
                    if (!window.confirm(tr('Marquer cette offre comme acceptée par le client ?')))
                      return;
                    accepter(selD, '');
                  }}
                />
              </div>
            )}
            <div style={{ marginTop: 8 }}>
              <Btn
                label={
                  termes.feminin
                    ? '📋 Dupliquer en nouvelle offre'
                    : '📋 Dupliquer en nouveau devis'
                }
                sm
                color={C.navy}
                full
                onClick={() => dupliquer(selD)}
              />
            </div>
            {/* Refusée par erreur : le patron la remet en attente. */}
            {estPatron && typeof selD.id === 'number' && (
              <div style={{ marginTop: 8 }}>
                <Btn
                  label={tr('↩ Refusé par erreur (remettre en attente)')}
                  sm
                  ghost
                  color={C.navy}
                  full
                  onClick={() => annulerLeRefus(selD)}
                />
              </div>
            )}
          </div>
        )}
        {/* La prochaine étape d'abord (réponse du client, facture) ; ajouter
            des articles, bon de commande et tampon sont rangés sous « ⋯ Plus ». */}
        <button
          type="button"
          aria-expanded={optOpen}
          onClick={() => setOptOpen((o) => !o)}
          style={{
            width: '100%',
            marginTop: 9,
            display: 'flex',
            justifyContent: 'center',
            gap: 6,
            padding: '10px 0',
            borderRadius: 11,
            border: '1px solid ' + C.border,
            background: C.white,
            color: C.navy,
            fontSize: 11.5,
            fontWeight: 800,
            cursor: 'pointer',
          }}
        >
          <span aria-hidden="true">⋯</span>
          <span>{tr('Plus')}</span>
          <span aria-hidden="true">{optOpen ? '▴' : '▾'}</span>
        </button>
        {optOpen && (
          <>
            <AjoutArticles
              catalogue={catalogue}
              setCatalogue={setCatalogue}
              stock={stock}
              soc={soc}
              estMag={estMag}
              client={clients.find((c) => c.id === selD.clientId)}
              libelleAjout={
                termes.feminin
                  ? '➕ Ajouter cette ligne à l’offre'
                  : '➕ Ajouter cette ligne au devis'
              }
              onAjout={(ligne) =>
                setDevis((p) =>
                  p.map((d) =>
                    d.id === selD.id ? { ...d, lignes: [...(d.lignes || []), ligne] } : d,
                  ),
                )
              }
            />

            {/* Le bon de commande à un sous-traitant est un outil du bâtiment : le
              magasin ne le voit pas (sauf pour défaire un ancien bon). */}
            {(!estMag || selD.bonCommande) && (
              <>
                <div
                  onClick={() =>
                    setDevis((p) =>
                      p.map((x) => (x.id === selD.id ? { ...x, bonCommande: !x.bonCommande } : x)),
                    )
                  }
                  style={{
                    marginTop: 9,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 9,
                    background: selD.bonCommande ? C.teal + '14' : C.navyXL,
                    border: '1px solid ' + (selD.bonCommande ? C.teal : C.border),
                    borderRadius: 11,
                    padding: '10px 12px',
                    cursor: 'pointer',
                  }}
                >
                  <span style={{ fontSize: 17 }}>📋</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 10.5, fontWeight: 800, color: C.ink }}>
                      Bon de commande (sous-traitance)
                    </div>
                    <div style={{ fontSize: 8, color: C.muted }}>
                      Transforme ce document en bon de commande adressé à un sous-traitant.
                    </div>
                  </div>
                  <div
                    style={{
                      width: 40,
                      height: 23,
                      borderRadius: 99,
                      background: selD.bonCommande ? C.green : C.border,
                      position: 'relative',
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        top: 2.5,
                        left: selD.bonCommande ? 19 : 2.5,
                        width: 18,
                        height: 18,
                        borderRadius: 99,
                        background: '#fff',
                      }}
                    />
                  </div>
                </div>
                {selD.bonCommande && (
                  <div
                    style={{
                      marginTop: 6,
                      fontSize: 8.5,
                      color: C.teal,
                      background: C.teal + '10',
                      borderRadius: 8,
                      padding: '7px 10px',
                      lineHeight: 1.5,
                    }}
                  >
                    📌 Ce document est un <b>bon de commande</b> : le destinataire (sélectionné
                    comme client) est ton <b>sous-traitant</b>. Le titre devient « BON DE COMMANDE »
                    et il n'y a pas de QR-facture.
                  </div>
                )}
              </>
            )}
            <div
              onClick={() => {
                // Sans tampon ni signature réglés, l'interrupteur s'allumait et
                // rien ne paraissait sur le PDF : il dit où les ajouter.
                if (!selD.tampon && !(soc?.tampon || soc?.sigPatron)) {
                  alert(tr(MSG_SANS_TAMPON));
                  return;
                }
                setDevis((p) => p.map((x) => (x.id === selD.id ? { ...x, tampon: !x.tampon } : x)));
              }}
              style={{
                marginTop: 9,
                display: 'flex',
                alignItems: 'center',
                gap: 9,
                background: selD.tampon ? C.purple + '14' : C.navyXL,
                border: '1px solid ' + (selD.tampon ? C.purple : C.border),
                borderRadius: 11,
                padding: '10px 12px',
                cursor: 'pointer',
              }}
            >
              <span style={{ fontSize: 17 }}>🔖</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 10.5, fontWeight: 800, color: C.ink }}>
                  Apposer le tampon + ma signature
                </div>
                <div style={{ fontSize: 8, color: C.muted }}>
                  Ajoute ton tampon et ta signature en bas du document.
                </div>
              </div>
              <div
                style={{
                  width: 40,
                  height: 23,
                  borderRadius: 99,
                  background: selD.tampon ? C.green : C.border,
                  position: 'relative',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: 2.5,
                    left: selD.tampon ? 19 : 2.5,
                    width: 18,
                    height: 18,
                    borderRadius: 99,
                    background: '#fff',
                  }}
                />
              </div>
            </div>
          </>
        )}
        {/* Le lien et ses boutons sont retirés (demande du patron) ; reste
            le suivi : quand le client a consulté l'offre. */}
        {!selD.bonCommande && (
          <CarteLienClient
            type="devis"
            suiviSeul
            id={selD.id}
            clientNom={clients.find((c) => c.id === selD.clientId)?.nom}
          />
        )}
      </Shell>
    );
  }

  /* DOCUMENT A4 */
  if (view === 'doc' && selD) {
    const cl = clients.find((c) => c.id === selD.clientId);
    const accent =
      docCol && docCol[0] === '#'
        ? docCol
        : DOC_COULEURS.find((c) => c.id === docCol)?.accent ||
          DEVIS_STYLES.find((s) => s.id === style)?.accent ||
          DA;
    const ov = selD.ov || {};
    const lieuAuto = (() => {
      const c = chantierLie(selD, chantiers);
      return c ? [c.adr, c.npa].filter(Boolean).join(', ') : '';
    })();
    const cle = {
      ...(cl || {}),
      nom: ov.nom || cl?.nom || '',
      adr: ov.adr || cl?.adr || '',
      npa: ov.npa || cl?.npa || '',
    };
    return (
      <DocumentA4
        soc={soc}
        client={cle}
        onClose={() => setView('detail')}
        annexe={
          <AnnexePhotos
            photos={photosAnnexe(selD, piecesDoc, adresseApi, { dansLesLignes: true })}
            soc={soc}
            titre={tr(termes.Mot) + ' ' + (selD.num || selD.id)}
            agrandit
          />
        }
        doc={{
          kind: 'devis',
          estMag,
          sect: selD.sect,
          noPay: selD.noPay,
          regie: selD.regie,
          bonCommande: selD.bonCommande,
          tampon: selD.tampon,
          accent,
          style,
          num: selD.num || selD.id,
          chantierId: selD.chantierId,
          projet: libelleProjet(selD, { chantiers }),
          refOv: ov.ref,
          // La reference de paiement de l'acompte, celle du PDF et de la
          // facture d'acompte : derivee du numero, elle se confondait avec
          // celle de la facture de meme numero.
          refId: selD.identifiantReference,
          chLieu: ov.lieu || lieuAuto,
          date: selD.date,
          ech: (() => {
            try {
              const p = (selD.date || today()).split('.');
              const d = new Date(+p[2], +p[1] - 1, +p[0]);
              d.setDate(d.getDate() + (selD.validite || 30));
              return (
                String(d.getDate()).padStart(2, '0') +
                '.' +
                String(d.getMonth() + 1).padStart(2, '0') +
                '.' +
                d.getFullYear()
              );
            } catch (e) {
              return (selD.validite || 30) + ' jours';
            }
          })(),
          delai: selD.delai,
          intro: selD.intro,
          mentions: selD.mentions,
          piedMessage: selD.piedMessage,
          stylesMessages: selD.stylesMessages,
          signatureClient: signatureDuClient(selD),
          plaque: selD.plaque,
          vehicule: selD.vehicule,
          commandeClient: selD.commandeClient,
          objet: selD.desc,
          ref: cl?.nom ? cl.nom.split(' ').slice(-1)[0].toUpperCase() : '',
          lignes: (selD.lignes || [])
            .filter((l) => (l.d || '').trim() !== '' || (+l.p || 0) !== 0)
            .map((l) => ({
              photo: photoDeLigne(l),
              d: l.d,
              sd: l.sd,
              hl: l.hl,
              q: l.q,
              u: l.u,
              p: l.p,
              rem: remEff(l),
              ref: l.ref,
              tva: l.tva,
              paliers: l.paliers,
            })),
          remisePct: selD.remisePct || 0,
          tvaPct: selD.tvaPct ?? TAUX_LEGAUX_ACTUELS.normal,
          acomptePct: selD.acompte || 0,
          acompteMontant: selD.acompteMontant || null,
          acompteDelai: soc?.acompteDelai ?? 10,
          recu: 0,
        }}
      />
    );
  }

  /* PLANCHE PHOTOS A4 */
  if (view === 'photos' && selD) {
    return (
      <PhotoSheetA4
        photos={photosPlanche(selD)}
        soc={soc}
        titre={tr(termes.Mot) + ' ' + (selD.num || selD.id)}
        onClose={() => setView('detail')}
      />
    );
  }

  /* VUE QR CLIENT (signature) */
  if (view === 'qr' && selD) {
    const cl = clients.find((c) => c.id === selD.clientId);
    const dTTC = ttcOf(selD);
    const dAcp = acompteDocument(
      selD.lignes,
      selD.tvaPct,
      selD.remisePct,
      selD.acompte,
      selD.acompteMontant,
    );
    if (qrEtape === 'accepte')
      return (
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: 'linear-gradient(160deg,' + C.green + ',#0A5C32)',
          }}
        >
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 24,
              textAlign: 'center',
            }}
          >
            <div style={{ fontSize: 60, marginBottom: 14 }}>✓</div>
            <div style={{ fontSize: 22, fontWeight: 900, color: '#fff', marginBottom: 6 }}>
              Merci {cl?.nom?.split(' ')[0]} !
            </div>
            <div
              style={{
                fontSize: 11,
                color: 'rgba(255,255,255,.75)',
                lineHeight: 1.7,
                marginBottom: 20,
              }}
            >
              Votre acceptation est enregistrée.
              {ouvreUnChantier(selD) && (
                <>
                  <br />
                  Un chantier a été créé automatiquement.
                </>
              )}
            </div>
            {selD.acompte > 0 && (
              <div
                style={{
                  background: 'rgba(255,255,255,.14)',
                  borderRadius: 14,
                  padding: 18,
                  marginBottom: 20,
                }}
              >
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,.7)', marginBottom: 8 }}>
                  QR-facture {libelleAcompte(selD).toLowerCase()}
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
                  <div style={{ background: '#fff', padding: 7, borderRadius: 8 }}>
                    <QRCode
                      size={120}
                      color={C.ink}
                      value={swissQR({
                        iban: soc?.iban || SOC.iban,
                        nom: soc?.nom || SOC.nom,
                        adr: soc?.adr || SOC.adr,
                        npa: soc?.npa || SOC.npa,
                        amount: dAcp,
                        clientNom: selD.ov?.nom || cl?.nom,
                        clientAdr: selD.ov?.adr || cl?.adr,
                        clientNpa: selD.ov?.npa || cl?.npa,
                        refType: docRef(selD.identifiantReference || selD.id, soc?.iban || SOC.iban)
                          .type,
                        ref:
                          (selD.ov?.ref && selD.ov.ref.trim()) ||
                          docRef(selD.identifiantReference || selD.id, soc?.iban || SOC.iban).ref,
                        msg: trf('Acompte {0} n° {1}', motDocument(termes), selD.num || ''),
                      })}
                    />
                  </div>
                </div>
                <div style={{ fontSize: 18, fontWeight: 900, color: '#fff' }}>
                  {DEVISE} {fmt(dAcp)}
                </div>
              </div>
            )}
            <Btn
              label="← Retour au logiciel"
              ghost
              color="#fff"
              text="#fff"
              onClick={() => setView('detail')}
            />
          </div>
        </div>
      );
    if (qrEtape === 'refuse')
      return (
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: C.redL,
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: 54 }}>✕</div>
          <div style={{ fontSize: 18, fontWeight: 900, color: C.red, margin: '10px 0' }}>
            {termes.Refuse}
          </div>
          <div style={{ fontSize: 11, color: C.grey, lineHeight: 1.6, marginBottom: 18 }}>
            Le refus a été enregistré.
          </div>
          <Btn label="← Retour" ghost color={C.red} onClick={() => setView('detail')} />
        </div>
      );
    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column', background: C.bg }}>
        <div
          style={{
            background: 'linear-gradient(90deg,' + C.navy + ',' + C.navyM + ')',
            padding: '12px 14px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <button
            onClick={() => setView('detail')}
            style={{
              background: 'none',
              border: 'none',
              color: '#fff',
              fontSize: 18,
              cursor: 'pointer',
            }}
          >
            ←
          </button>
          <span style={{ fontSize: 11, fontWeight: 700, color: '#fff' }}>
            Espace client sécurisé
          </span>
          <Pill label="🔒 SSL" color={C.green} size={8} />
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: 13 }}>
          <div
            style={{
              background: C.greenL,
              border: '1px solid ' + C.green + '28',
              borderRadius: 10,
              padding: '10px 12px',
              fontSize: 9.5,
              color: C.grey,
              marginBottom: 11,
              lineHeight: 1.5,
            }}
          >
            Bonjour {cl?.nom}, voici votre {motDoc}. Vous pouvez l'accepter en signant ci-dessous.
          </div>
          <Card style={{ marginBottom: 11 }}>
            <div style={{ padding: '12px 14px', borderBottom: '3px solid ' + C.navy }}>
              <div style={{ fontSize: 13, fontWeight: 900, color: C.ink }}>
                {selD.num || selD.id}
              </div>
              <div style={{ fontSize: 8, color: C.muted }}>{soc?.nom || SOC.nom}</div>
            </div>
            <div style={{ padding: '10px 14px' }}>
              {(selD.lignes || []).map((l, i) => (
                <div
                  key={i}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '5px 0',
                    borderBottom: '1px solid ' + C.border,
                    fontSize: 9.5,
                  }}
                >
                  <span>
                    {l.q} {l.u} × {l.d}
                  </span>
                  <span style={{ fontWeight: 700 }}>
                    {DEVISE} {fmt((+l.q || 0) * prixApplique(l) * (1 - (l.rem || 0) / 100))}
                  </span>
                </div>
              ))}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: 8,
                  padding: '8px 11px',
                  background: C.navy,
                  borderRadius: 8,
                }}
              >
                <span style={{ fontSize: 10, fontWeight: 700, color: '#fff' }}>Total TTC</span>
                <span style={{ fontSize: 14, fontWeight: 900, color: '#fff' }}>
                  {DEVISE} {fmt(dTTC)}
                </span>
              </div>
            </div>
          </Card>
          <Card style={{ marginBottom: 11 }}>
            <Bar
              icon="✍️"
              title="Votre signature électronique"
              color={C.navy}
              sub="Valeur légale d'acceptation"
            />
            <div style={{ padding: 13 }}>
              <SignPad value={sig} onChange={setSig} color={C.navy} />
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 10 }}>
                <Btn
                  label="✓ J'accepte et je signe"
                  color={C.green}
                  full
                  disabled={!sig}
                  onClick={() => accepter(selD)}
                />
                <Btn
                  label={termes.feminin ? 'Refuser l’offre' : 'Refuser le devis'}
                  ghost
                  danger
                  full
                  onClick={() => refuser(selD)}
                />
              </div>
            </div>
          </Card>
        </div>
      </div>
    );
  }

  // Aucune vue ne s'applique : la piece choisie vient de changer de numero, et
  // l'effet ci-dessus ramene a la liste au rendu suivant. Rendre la liste
  // plutot que rien evite le clignotement d'une page blanche.
  return null;
} /**
 * Le mot de la pièce (« offre », « devis »…) dans la langue des documents.
 *
 * <p>Le mot choisi dans les réglages est français : traduit s'il est connu du
 * dictionnaire, il reste tel quel sinon — c'est le nom que le patron a voulu.
 *
 * @param {{mot: string, Mot: string}} termes terminologie de la pièce
 * @returns {string} le mot à écrire sur la pièce
 */
function motDocument(termes) {
  const traduit = tr(termes.Mot);
  return traduit === termes.Mot ? termes.mot : traduit;
}
